// Minecraft Crafting Recipes Database
// Links to sprite IDs from resource calculator

// ==========================================
// MATERIAL TAGS (for flexible recipes)
// ==========================================
const materialTags = {
  planks: [
    'oak-planks', 'spruce-planks', 'birch-planks', 'jungle-planks',
    'acacia-planks', 'dark-oak-planks', 'mangrove-planks', 'cherry-planks',
    'bamboo-planks', 'crimson-planks', 'warped-planks',
  ],
  logs: [
    'oak-log', 'spruce-log', 'birch-log', 'jungle-log',
    'acacia-log', 'dark-oak-log', 'mangrove-log', 'cherry-log',
    'crimson-stem', 'warped-stem',
  ],
  slabs: [
    'oak-slab', 'spruce-slab', 'birch-slab', 'jungle-slab',
    'acacia-slab', 'dark-oak-slab', 'mangrove-slab', 'cherry-slab',
    'bamboo-slab', 'crimson-slab', 'warped-slab',
  ],
  coal: ['coal', 'charcoal'],
  'soul-soil-or-sand': ['soul-soil', 'soul-sand'],
  'stone-tier': ['cobblestone', 'blackstone', 'cobbled-deepslate'],
};

// ==========================================
// CRAFTING RECIPES DATABASE
// ==========================================
const craftingRecipes = {
  
// ==========================================
// BASE RESOURCES (Cleaned & Unique)
// ==========================================
'oak-log': { id: 'oak-log', name: 'Oak Log', isBaseResource: true },
'copper-golem': { id: 'copper-golem', name: 'Copper Golem', isBaseResource: true },
'spruce-log': { id: 'spruce-log', name: 'Spruce Log', isBaseResource: true },
'birch-log': { id: 'birch-log', name: 'Birch Log', isBaseResource: true },
'jungle-log': { id: 'jungle-log', name: 'Jungle Log', isBaseResource: true },
'acacia-log': { id: 'acacia-log', name: 'Acacia Log', isBaseResource: true },
'dark-oak-log': { id: 'dark-oak-log', name: 'Dark Oak Log', isBaseResource: true },
'mangrove-log': { id: 'mangrove-log', name: 'Mangrove Log', isBaseResource: true },
'cherry-log': { id: 'cherry-log', name: 'Cherry Log', isBaseResource: true },
'pale-oak-log': { id: 'pale-oak-log', name: 'Pale Oak Log', isBaseResource: true },
'crimson-stem': { id: 'crimson-stem', name: 'Crimson Stem', isBaseResource: true },
'warped-stem': { id: 'warped-stem', name: 'Warped Stem', isBaseResource: true },
'bamboo': { id: 'bamboo', name: 'Bamboo', isBaseResource: true },
'cobblestone': { id: 'cobblestone', name: 'Cobblestone', isBaseResource: true },
'granite': { id: 'granite', name: 'Granite', isBaseResource: true },
'diorite': { id: 'diorite', name: 'Diorite', isBaseResource: true },
'andesite': { id: 'andesite', name: 'Andesite', isBaseResource: true },
'deepslate': { id: 'deepslate', name: 'Deepslate', isBaseResource: true },
'cobbled-deepslate': { id: 'cobbled-deepslate', name: 'Cobbled Deepslate', isBaseResource: true },
'sand': { id: 'sand', name: 'Sand', isBaseResource: true },
'red-sand': { id: 'red-sand', name: 'Red Sand', isBaseResource: true },
'prismarine-shard': { id: 'prismarine-shard', name: 'Prismarine Shard', isBaseResource: true },
'prismarine-crystals': { id: 'prismarine-crystals', name: 'Prismarine Crystals', isBaseResource: true },
'blackstone': { id: 'blackstone', name: 'Blackstone', isBaseResource: true },
'netherrack': { id: 'netherrack', name: 'Netherrack', isBaseResource: true },
'nether-wart': { id: 'nether-wart', name: 'Nether Wart', isBaseResource: true },
'basalt': { id: 'basalt', name: 'Basalt', isBaseResource: true },
'soul-sand': { id: 'soul-sand', name: 'Soul Sand', isBaseResource: true },
'soul-soil': { id: 'soul-soil', name: 'Soul Soil', isBaseResource: true },
'end-stone': { id: 'end-stone', name: 'End Stone', isBaseResource: true },
'clay-ball': { id: 'clay-ball', name: 'Clay Ball', isBaseResource: true },
'clay': { id: 'clay', name: 'Clay Block', isBaseResource: true },
'mud': { id: 'mud', name: 'Mud', isBaseResource: true },
'wheat': { id: 'wheat', name: 'Wheat', isBaseResource: true },
'sugar-cane': { id: 'sugar-cane', name: 'Sugar Cane', isBaseResource: true },
'cocoa-beans': { id: 'cocoa-beans', name: 'Cocoa Beans', isBaseResource: true },
'chorus-fruit': { id: 'chorus-fruit', name: 'Chorus Fruit', isBaseResource: true },
'nether-quartz': { id: 'nether-quartz', name: 'Nether Quartz', isBaseResource: true },
'copper-ore': { id: 'copper-ore', name: 'Copper Ore', isBaseResource: true },
'deepslate-copper-ore': { id: 'deepslate-copper-ore', name: 'Deepslate Copper Ore', isBaseResource: true },
'raw-copper': { id: 'raw-copper', name: 'Raw Copper', isBaseResource: true },
'copper-ingot': { id: 'copper-ingot', name: 'Copper Ingot', isBaseResource: true },
'honeycomb': { id: 'honeycomb', name: 'Honeycomb', isBaseResource: true },
'white-dye': { id: 'white-dye', name: 'White Dye', isBaseResource: true },
'orange-dye': { id: 'orange-dye', name: 'Orange Dye', isBaseResource: true },
'magenta-dye': { id: 'magenta-dye', name: 'Magenta Dye', isBaseResource: true },
'light-blue-dye': { id: 'light-blue-dye', name: 'Light Blue Dye', isBaseResource: true },
'yellow-dye': { id: 'yellow-dye', name: 'Yellow Dye', isBaseResource: true },
'lime-dye': { id: 'lime-dye', name: 'Lime Dye', isBaseResource: true },
'pink-dye': { id: 'pink-dye', name: 'Pink Dye', isBaseResource: true },
'gray-dye': { id: 'gray-dye', name: 'Gray Dye', isBaseResource: true },
'light-gray-dye': { id: 'light-gray-dye', name: 'Light Gray Dye', isBaseResource: true },
'cyan-dye': { id: 'cyan-dye', name: 'Cyan Dye', isBaseResource: true },
'purple-dye': { id: 'purple-dye', name: 'Purple Dye', isBaseResource: true },
'blue-dye': { id: 'blue-dye', name: 'Blue Dye', isBaseResource: true },
'brown-dye': { id: 'brown-dye', name: 'Brown Dye', isBaseResource: true },
'green-dye': { id: 'green-dye', name: 'Green Dye', isBaseResource: true },
'red-dye': { id: 'red-dye', name: 'Red Dye', isBaseResource: true },
'black-dye': { id: 'black-dye', name: 'Black Dye', isBaseResource: true },
'gravel': { id: 'gravel', name: 'Gravel', isBaseResource: true },
'white-wool': { id: 'white-wool', name: 'White Wool', isBaseResource: true },
'amethyst-shard': { id: 'amethyst-shard', name: 'Amethyst Shard', isBaseResource: true },
'calcite': { id: 'calcite', name: 'Calcite', isBaseResource: true },
'tuff': { id: 'tuff', name: 'Tuff', isBaseResource: true },
'dripstone-block': { id: 'dripstone-block', name: 'Dripstone Block', isBaseResource: true },
'magma-cream': { id: 'magma-cream', name: 'Magma Cream', isBaseResource: true },
'warped-wart-block': { id: 'warped-wart-block', name: 'Warped Wart Block', isBaseResource: true },
'bone-meal': { id: 'bone-meal', name: 'Bone Meal', isBaseResource: true },
'dried-kelp': { id: 'dried-kelp', name: 'Dried Kelp', isBaseResource: true },
'moss-block': { id: 'moss-block', name: 'Moss Block', isBaseResource: true },
'dirt': { id: 'dirt', name: 'Dirt', isBaseResource: true },
'grass-block': { id: 'grass-block', name: 'Grass Block', isBaseResource: true },
'podzol': { id: 'podzol', name: 'Podzol', isBaseResource: true },
'mycelium': { id: 'mycelium', name: 'Mycelium', isBaseResource: true },
'ice': { id: 'ice', name: 'Ice', isBaseResource: true },
'snowball': { id: 'snowball', name: 'Snowball', isBaseResource: true },
'powder-snow': { id: 'powder-snow', name: 'Powder Snow', isBaseResource: true },
'obsidian': { id: 'obsidian', name: 'Obsidian', isBaseResource: true },
'crying-obsidian': { id: 'crying-obsidian', name: 'Crying Obsidian', isBaseResource: true },
'glowstone-dust': { id: 'glowstone-dust', name: 'Glowstone Dust', isBaseResource: true },
'shroomlight': { id: 'shroomlight', name: 'Shroomlight', isBaseResource: true },
'iron-ingot': { id: 'iron-ingot', name: 'Iron Ingot', isBaseResource: true },
'iron-block': { id: 'iron-block', name: 'Block of Iron', isBaseResource: true },
'string': { id: 'string', name: 'String', isBaseResource: true },
'paper': { id: 'paper', name: 'Paper', isBaseResource: true },
'flint': { id: 'flint', name: 'Flint', isBaseResource: true },
'shulker-shell': { id: 'shulker-shell', name: 'Shulker Shell', isBaseResource: true },
'slime-ball': { id: 'slime-ball', name: 'Slime Ball', isBaseResource: true },
'bow': { id: 'bow', name: 'Bow', isBaseResource: true },
'redstone': { id: 'redstone', name: 'Redstone Dust', isBaseResource: true },
'coal': { id: 'coal', name: 'Coal', isBaseResource: true },
'charcoal': { id: 'charcoal', name: 'Charcoal', isBaseResource: true },
'iron-nugget': { id: 'iron-nugget', name: 'Iron Nugget', isBaseResource: true },
'blaze-rod': { id: 'blaze-rod', name: 'Blaze Rod', isBaseResource: true },
'carved-pumpkin': { id: 'carved-pumpkin', name: 'Carved Pumpkin', isBaseResource: true },
'iron-ore': { id: 'iron-ore', name: 'Iron Ore', isBaseResource: true },
'deepslate-iron-ore': { id: 'deepslate-iron-ore', name: 'Deepslate Iron Ore', isBaseResource: true },
'raw-iron': { id: 'raw-iron', name: 'Raw Iron', isBaseResource: true },
'gold-ore': { id: 'gold-ore', name: 'Gold Ore', isBaseResource: true },
'deepslate-gold-ore': { id: 'deepslate-gold-ore', name: 'Deepslate Gold Ore', isBaseResource: true },
'nether-gold-ore': { id: 'nether-gold-ore', name: 'Nether Gold Ore', isBaseResource: true },
'raw-gold': { id: 'raw-gold', name: 'Raw Gold', isBaseResource: true },
'gold-ingot': { id: 'gold-ingot', name: 'Gold Ingot', isBaseResource: true },
'diamond-ore': { id: 'diamond-ore', name: 'Diamond Ore', isBaseResource: true },
'deepslate-diamond-ore': { id: 'deepslate-diamond-ore', name: 'Deepslate Diamond Ore', isBaseResource: true },
'diamond': { id: 'diamond', name: 'Diamond', isBaseResource: true },
'emerald-ore': { id: 'emerald-ore', name: 'Emerald Ore', isBaseResource: true },
'deepslate-emerald-ore': { id: 'deepslate-emerald-ore', name: 'Deepslate Emerald Ore', isBaseResource: true },
'emerald': { id: 'emerald', name: 'Emerald', isBaseResource: true },
'lapis-ore': { id: 'lapis-ore', name: 'Lapis Lazuli Ore', isBaseResource: true },
'deepslate-lapis-ore': { id: 'deepslate-lapis-ore', name: 'Deepslate Lapis Lazuli Ore', isBaseResource: true },
'lapis-lazuli': { id: 'lapis-lazuli', name: 'Lapis Lazuli', isBaseResource: true },
'coal-ore': { id: 'coal-ore', name: 'Coal Ore', isBaseResource: true },
'deepslate-coal-ore': { id: 'deepslate-coal-ore', name: 'Deepslate Coal Ore', isBaseResource: true },
'redstone-ore': { id: 'redstone-ore', name: 'Redstone Ore', isBaseResource: true },
'deepslate-redstone-ore': { id: 'deepslate-redstone-ore', name: 'Deepslate Redstone Ore', isBaseResource: true },
'nether-quartz-ore': { id: 'nether-quartz-ore', name: 'Nether Quartz Ore', isBaseResource: true },
'ancient-debris': { id: 'ancient-debris', name: 'Ancient Debris', isBaseResource: true },
'netherite-scrap': { id: 'netherite-scrap', name: 'Netherite Scrap', isBaseResource: true },
'netherite-ingot': { id: 'netherite-ingot', name: 'Netherite Ingot', isBaseResource: true },
'nautilus-shell': { id: 'nautilus-shell', name: 'Nautilus Shell', isBaseResource: true },
'heart-of-the-sea': { id: 'heart-of-the-sea', name: 'Heart of the Sea', isBaseResource: true },
'egg': { id: 'egg', name: 'Egg', isBaseResource: true },
'milk-bucket': { id: 'milk-bucket', name: 'Milk Bucket', isBaseResource: true },
'bucket': { id: 'bucket', name: 'Bucket', isBaseResource: true },
'apple': { id: 'apple', name: 'Apple', isBaseResource: true },
'carrot': { id: 'carrot', name: 'Carrot', isBaseResource: true },
'potato': { id: 'potato', name: 'Potato', isBaseResource: true },
'beetroot': { id: 'beetroot', name: 'Beetroot', isBaseResource: true },
'melon-slice': { id: 'melon-slice', name: 'Melon Slice', isBaseResource: true },
'sweet-berries': { id: 'sweet-berries', name: 'Sweet Berries', isBaseResource: true },
'glow-berries': { id: 'glow-berries', name: 'Glow Berries', isBaseResource: true },
'pumpkin': { id: 'pumpkin', name: 'Pumpkin', isBaseResource: true },
'kelp': { id: 'kelp', name: 'Kelp', isBaseResource: true },
'brown-mushroom': { id: 'brown-mushroom', name: 'Brown Mushroom', isBaseResource: true },
'red-mushroom': { id: 'red-mushroom', name: 'Red Mushroom', isBaseResource: true },
'beef': { id: 'beef', name: 'Raw Beef', isBaseResource: true },
'porkchop': { id: 'porkchop', name: 'Raw Porkchop', isBaseResource: true },
'chicken': { id: 'chicken', name: 'Raw Chicken', isBaseResource: true },
'mutton': { id: 'mutton', name: 'Raw Mutton', isBaseResource: true },
'rabbit': { id: 'rabbit', name: 'Raw Rabbit', isBaseResource: true },
'cod': { id: 'cod', name: 'Raw Cod', isBaseResource: true },
'salmon': { id: 'salmon', name: 'Raw Salmon', isBaseResource: true },
'tropical-fish': { id: 'tropical-fish', name: 'Tropical Fish', isBaseResource: true },
'pufferfish': { id: 'pufferfish', name: 'Pufferfish', isBaseResource: true },
'leather': { id: 'leather', name: 'Leather', isBaseResource: true },
'feather': { id: 'feather', name: 'Feather', isBaseResource: true },
'ink-sac': { id: 'ink-sac', name: 'Ink Sac', isBaseResource: true },
'glow-ink-sac': { id: 'glow-ink-sac', name: 'Glow Ink Sac', isBaseResource: true },
'echo-shard': { id: 'echo-shard', name: 'Echo Shard', isBaseResource: true },
'gunpowder': { id: 'gunpowder', name: 'Gunpowder', isBaseResource: true },
'eye-of-ender': { id: 'eye-of-ender', name: 'Eye of Ender', isBaseResource: true },
'trident': { id: 'trident', name: 'Trident', isBaseResource: true },
'scute': { id: 'scute', name: 'Scute', isBaseResource: true },
'iron-horse-armor': { id: 'iron-horse-armor', name: 'Iron Horse Armor', isBaseResource: true },
'golden-horse-armor': { id: 'golden-horse-armor', name: 'Golden Horse Armor', isBaseResource: true },
'diamond-horse-armor': { id: 'diamond-horse-armor', name: 'Diamond Horse Armor', isBaseResource: true },
'copper-horse-armor': { id: 'copper-horse-armor', name: 'Copper Horse Armor', isBaseResource: true },
'chainmail-helmet': { id: 'chainmail-helmet', name: 'Chainmail Helmet', isBaseResource: true },
'chainmail-chestplate': { id: 'chainmail-chestplate', name: 'Chainmail Chestplate', isBaseResource: true },
'chainmail-leggings': { id: 'chainmail-leggings', name: 'Chainmail Leggings', isBaseResource: true },
'chainmail-boots': { id: 'chainmail-boots', name: 'Chainmail Boots', isBaseResource: true },
'elytra': { id: 'elytra', name: 'Elytra', isBaseResource: true },
'resin-clump': { id: 'resin-clump', name: 'Resin Clump', isBaseResource: true },
'glass-bottle': { id: 'glass-bottle', name: 'Glass Bottle', isBaseResource: true },
'enchanted-book': { id: 'enchanted-book', name: 'Enchanted Book', isBaseResource: true },
'experience-bottle': { id: 'experience-bottle', name: 'Bottle o\' Enchanting', isBaseResource: true },
'potion': { id: 'potion', name: 'Potion', isBaseResource: true },
'splash-potion': { id: 'splash-potion', name: 'Splash Potion', isBaseResource: true },
'lingering-potion': { id: 'lingering-potion', name: 'Lingering Potion', isBaseResource: true },
'saddle': { id: 'saddle', name: 'Saddle', isBaseResource: true },
'creaking-heart': { id: 'creaking-heart', name: 'Creaking Heart', isBaseResource: true },
'pale-moss-block': { id: 'pale-moss-block', name: 'Pale Moss Block', isBaseResource: true },
'pale-hanging-moss': { id: 'pale-hanging-moss', name: 'Pale Hanging Moss', isBaseResource: true },
'open-eyeblossom': { id: 'open-eyeblossom', name: 'Open Eyeblossom', isBaseResource: true },
'closed-eyeblossom': { id: 'closed-eyeblossom', name: 'Closed Eyeblossom', isBaseResource: true },
'breeze-rod': { id: 'breeze-rod', name: 'Breeze Rod', isBaseResource: true },
'heavy-core': { id: 'heavy-core', name: 'Heavy Core', isBaseResource: true },
'trial-key': { id: 'trial-key', name: 'Trial Key', isBaseResource: true },
'ominous-trial-key': { id: 'ominous-trial-key', name: 'Ominous Trial Key', isBaseResource: true },
'ominous-bottle': { id: 'ominous-bottle', name: 'Ominous Bottle', isBaseResource: true },
'trial-spawner': { id: 'trial-spawner', name: 'Trial Spawner', isBaseResource: true },
'vault': { id: 'vault', name: 'Vault', isBaseResource: true },
'bush': { id: 'bush', name: 'Bush', isBaseResource: true },
'cactus-flower': { id: 'cactus-flower', name: 'Cactus Flower', isBaseResource: true },
'firefly-bush': { id: 'firefly-bush', name: 'Firefly Bush', isBaseResource: true },
'leaf-litter': { id: 'leaf-litter', name: 'Leaf Litter', isBaseResource: true },
'wildflowers': { id: 'wildflowers', name: 'Wildflowers', isBaseResource: true },
'short-dry-grass': { id: 'short-dry-grass', name: 'Short Dry Grass', isBaseResource: true },
'tall-dry-grass': { id: 'tall-dry-grass', name: 'Tall Dry Grass', isBaseResource: true },
'blue-egg': { id: 'blue-egg', name: 'Blue Egg', isBaseResource: true },
'brown-egg': { id: 'brown-egg', name: 'Brown Egg', isBaseResource: true },
'armadillo-scute': { id: 'armadillo-scute', name: 'Armadillo Scute', isBaseResource: true },
'netherite-upgrade-smithing-template': { id: 'netherite-upgrade-smithing-template', name: 'Netherite Upgrade', isBaseResource: true },
'block-of-stripped-bamboo': { id: 'block-of-stripped-bamboo', name: 'Block of Stripped Bamboo', isBaseResource: true },
'stripped-oak-log': { id: 'stripped-oak-log', name: 'Stripped Oak Log', isBaseResource: true },
'stripped-spruce-log': { id: 'stripped-spruce-log', name: 'Stripped Spruce Log', isBaseResource: true },
'stripped-birch-log': { id: 'stripped-birch-log', name: 'Stripped Birch Log', isBaseResource: true },
'stripped-jungle-log': { id: 'stripped-jungle-log', name: 'Stripped Jungle Log', isBaseResource: true },
'stripped-acacia-log': { id: 'stripped-acacia-log', name: 'Stripped Acacia Log', isBaseResource: true },
'stripped-dark-oak-log': { id: 'stripped-dark-oak-log', name: 'Stripped Dark Oak Log', isBaseResource: true },
'stripped-mangrove-log': { id: 'stripped-mangrove-log', name: 'Stripped Mangrove Log', isBaseResource: true },
'stripped-cherry-log': { id: 'stripped-cherry-log', name: 'Stripped Cherry Log', isBaseResource: true },
'stripped-pale-oak-log': { id: 'stripped-pale-oak-log', name: 'Stripped Pale Oak Log', isBaseResource: true },
'stripped-crimson-stem': { id: 'stripped-crimson-stem', name: 'Stripped Crimson Stem', isBaseResource: true },
'stripped-warped-stem': { id: 'stripped-warped-stem', name: 'Stripped Warped Stem', isBaseResource: true },
'stripped-bamboo-block': { id: 'stripped-bamboo-block', name: 'Stripped Bamboo Block', isBaseResource: true },
'stripped-oak-wood': { id: 'stripped-oak-wood', name: 'Stripped Oak Wood', isBaseResource: true },
'stripped-spruce-wood': { id: 'stripped-spruce-wood', name: 'Stripped Spruce Wood', isBaseResource: true },
'stripped-birch-wood': { id: 'stripped-birch-wood', name: 'Stripped Birch Wood', isBaseResource: true },
'stripped-jungle-wood': { id: 'stripped-jungle-wood', name: 'Stripped Jungle Wood', isBaseResource: true },
'stripped-acacia-wood': { id: 'stripped-acacia-wood', name: 'Stripped Acacia Wood', isBaseResource: true },
'stripped-dark-oak-wood': { id: 'stripped-dark-oak-wood', name: 'Stripped Dark Oak Wood', isBaseResource: true },
'stripped-mangrove-wood': { id: 'stripped-mangrove-wood', name: 'Stripped Mangrove Wood', isBaseResource: true },
'stripped-cherry-wood': { id: 'stripped-cherry-wood', name: 'Stripped Cherry Wood', isBaseResource: true },
'stripped-pale-oak-wood': { id: 'stripped-pale-oak-wood', name: 'Stripped Pale Oak Wood', isBaseResource: true },
'stripped-crimson-hyphae': { id: 'stripped-crimson-hyphae', name: 'Stripped Crimson Hyphae', isBaseResource: true },
'stripped-warped-hyphae': { id: 'stripped-warped-hyphae', name: 'Stripped Warped Hyphae', isBaseResource: true },
'chest': { id: 'chest', name: 'Chest', isBaseResource: true },
'copper-golem-spawn-egg': { id: 'copper-golem-spawn-egg', name: 'Copper Golem Spawn Egg', isBaseResource: true },
'gilded-blackstone': { id: 'gilded-blackstone', name: 'Gilded Blackstone', isBaseResource: true },
'exposed-copper': { id: 'exposed-copper', name: 'Exposed Copper', isBaseResource: true },
'weathered-copper': { id: 'weathered-copper', name: 'Weathered Copper', isBaseResource: true },
'oxidized-copper': { id: 'oxidized-copper', name: 'Oxidized Copper', isBaseResource: true },
'rooted-dirt': { id: 'rooted-dirt', name: 'Rooted Dirt', isBaseResource: true },
'nether-star': { id: 'nether-star', name: 'Nether Star', isBaseResource: true },
'suspicious-stew': { id: 'suspicious-stew', name: 'Suspicious Stew', isBaseResource: true },
'honey-bottle': { id: 'honey-bottle', name: 'Honey Bottle', isBaseResource: true },
'mangrove-roots': { id: 'mangrove-roots', name: 'Mangrove Roots', isBaseResource: true },



// ==========================================
// CRAFTED / SPECIAL RECIPES
// ==========================================
'pale-moss-carpet': { id: 'pale-moss-carpet', name: 'Pale Moss Carpet', recipes: [{ method: 'crafting_table', output: 3, ingredients: [{ id: 'pale-moss-block', amount: 2 }] }] },
'wind-charge': { id: 'wind-charge', name: 'Wind Charge', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'breeze-rod', amount: 1 }] }] },
'mace': { id: 'mace', name: 'Mace', recipes: [{ method: 'crafting_table', output: 1, ingredients: [{ id: 'heavy-core', amount: 1 }, { id: 'breeze-rod', amount: 1 }] }] },


// ==========================================
// SMELTED BASE ITEMS
// ==========================================

'cinnabar': { id: 'cinnabar', name: 'Cinnabar', isBaseResource: true },

'cinnabar-stairs': { id: 'cinnabar-stairs', name: 'Cinnabar Stairs', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'cinnabar', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'cinnabar', amount: 1 }] }] },
'cinnabar-slab': { id: 'cinnabar-slab', name: 'Cinnabar Slab', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'cinnabar', amount: 3 }] }, { method: 'stonecutter', output: 2, priority: true, ingredients: [{ id: 'cinnabar', amount: 1 }] }] },
'cinnabar-wall': { id: 'cinnabar-wall', name: 'Cinnabar Wall', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'cinnabar', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'cinnabar', amount: 1 }] }] },

'polished-cinnabar': { id: 'polished-cinnabar', name: 'Polished Cinnabar', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'cinnabar', amount: 4 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'cinnabar', amount: 1 }] }] },
'polished-cinnabar-stairs': { id: 'polished-cinnabar-stairs', name: 'Polished Cinnabar Stairs', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'polished-cinnabar', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-cinnabar', amount: 1 }] }] },
'polished-cinnabar-slab': { id: 'polished-cinnabar-slab', name: 'Polished Cinnabar Slab', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'polished-cinnabar', amount: 3 }] }, { method: 'stonecutter', output: 2, priority: true, ingredients: [{ id: 'polished-cinnabar', amount: 1 }] }] },
'polished-cinnabar-wall': { id: 'polished-cinnabar-wall', name: 'Polished Cinnabar Wall', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'polished-cinnabar', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-cinnabar', amount: 1 }] }] },

'cinnabar-bricks': { id: 'cinnabar-bricks', name: 'Cinnabar Bricks', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'polished-cinnabar', amount: 4 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-cinnabar', amount: 1 }] }] },
'cinnabar-brick-stairs': { id: 'cinnabar-brick-stairs', name: 'Cinnabar Brick Stairs', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'cinnabar-bricks', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'cinnabar-bricks', amount: 1 }] }] },
'cinnabar-brick-slab': { id: 'cinnabar-brick-slab', name: 'Cinnabar Brick Slab', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'cinnabar-bricks', amount: 3 }] }, { method: 'stonecutter', output: 2, priority: true, ingredients: [{ id: 'cinnabar-bricks', amount: 1 }] }] },
'cinnabar-brick-wall': { id: 'cinnabar-brick-wall', name: 'Cinnabar Brick Wall', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'cinnabar-bricks', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'cinnabar-bricks', amount: 1 }] }] },

'chiseled-cinnabar': { id: 'chiseled-cinnabar', name: 'Chiseled Cinnabar', recipes: [{ method: 'crafting_table', output: 1, ingredients: [{ id: 'cinnabar-slab', amount: 2 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'cinnabar', amount: 1 }] }] },


'sulfur': { id: 'sulfur', name: 'Sulfur', isBaseResource: true },

'sulfur-stairs': { id: 'sulfur-stairs', name: 'Sulfur Stairs', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'sulfur', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'sulfur', amount: 1 }] }] },
'sulfur-slab': { id: 'sulfur-slab', name: 'Sulfur Slab', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'sulfur', amount: 3 }] }, { method: 'stonecutter', output: 2, priority: true, ingredients: [{ id: 'sulfur', amount: 1 }] }] },
'sulfur-wall': { id: 'sulfur-wall', name: 'Sulfur Wall', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'sulfur', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'sulfur', amount: 1 }] }] },

'polished-sulfur': { id: 'polished-sulfur', name: 'Polished Sulfur', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'sulfur', amount: 4 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'sulfur', amount: 1 }] }] },
'polished-sulfur-stairs': { id: 'polished-sulfur-stairs', name: 'Polished Sulfur Stairs', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'polished-sulfur', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-sulfur', amount: 1 }] }] },
'polished-sulfur-slab': { id: 'polished-sulfur-slab', name: 'Polished Sulfur Slab', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'polished-sulfur', amount: 3 }] }, { method: 'stonecutter', output: 2, priority: true, ingredients: [{ id: 'polished-sulfur', amount: 1 }] }] },
'polished-sulfur-wall': { id: 'polished-sulfur-wall', name: 'Polished Sulfur Wall', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'polished-sulfur', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-sulfur', amount: 1 }] }] },

'sulfur-bricks': { id: 'sulfur-bricks', name: 'Sulfur Bricks', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'polished-sulfur', amount: 4 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-sulfur', amount: 1 }] }] },
'sulfur-brick-stairs': { id: 'sulfur-brick-stairs', name: 'Sulfur Brick Stairs', recipes: [{ method: 'crafting_table', output: 4, ingredients: [{ id: 'sulfur-bricks', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'sulfur-bricks', amount: 1 }] }] },
'sulfur-brick-slab': { id: 'sulfur-brick-slab', name: 'Sulfur Brick Slab', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'sulfur-bricks', amount: 3 }] }, { method: 'stonecutter', output: 2, priority: true, ingredients: [{ id: 'sulfur-bricks', amount: 1 }] }] },
'sulfur-brick-wall': { id: 'sulfur-brick-wall', name: 'Sulfur Brick Wall', recipes: [{ method: 'crafting_table', output: 6, ingredients: [{ id: 'sulfur-bricks', amount: 6 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'sulfur-bricks', amount: 1 }] }] },

'chiseled-sulfur': { id: 'chiseled-sulfur', name: 'Chiseled Sulfur', recipes: [{ method: 'crafting_table', output: 1, ingredients: [{ id: 'sulfur-slab', amount: 2 }] }, { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'sulfur', amount: 1 }] }] },
'potent-sulfur': { id: 'potent-sulfur', name: 'Potent Sulfur', recipes: [{ method: 'crafting_table', output: 1, ingredients: [{ id: 'sulfur', amount: 1 }, { id: 'blaze-powder', amount: 1 }] }] },


'stone': {
  id: 'stone',
  name: 'Stone',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'cobblestone', amount: 1 }]
  }]
},


'nether-brick-item': {
  id: 'nether-brick-item',
  name: 'Nether Brick (Item)',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'netherrack', amount: 1 }]
  }]
},


'brick': {
  id: 'brick',
  name: 'Brick (Item)',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'clay-ball', amount: 1 }]
  }]
},


'terracotta': {
  id: 'terracotta',
  name: 'Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'clay', amount: 1 }]
  }]
},

'decorated-pot': {
  id: 'decorated-pot',
  name: 'Decorated Pot',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'brick', amount: 4 } // Default version using 4 bricks
    ]
  }]
},


'glass': {
  id: 'glass',
  name: 'Glass',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'sand', amount: 1 }]
  }]
},


'stick': {
  id: 'stick',
  name: 'Stick',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { tag: 'planks', amount: 2 }
    ]
  }]
},


// ==========================================
// PLANKS & WOOD CATEGORY
// ==========================================

'oak-planks': {
  id: 'oak-planks',
  name: 'Oak Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'oak-log', amount: 1 }]
  }]
},

'spruce-planks': {
  id: 'spruce-planks',
  name: 'Spruce Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'spruce-log', amount: 1 }]
  }]
},

'birch-planks': {
  id: 'birch-planks',
  name: 'Birch Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'birch-log', amount: 1 }]
  }]
},

'jungle-planks': {
  id: 'jungle-planks',
  name: 'Jungle Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'jungle-log', amount: 1 }]
  }]
},

'acacia-planks': {
  id: 'acacia-planks',
  name: 'Acacia Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'acacia-log', amount: 1 }]
  }]
},

'dark-oak-planks': {
  id: 'dark-oak-planks',
  name: 'Dark Oak Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'dark-oak-log', amount: 1 }]
  }]
},

'mangrove-planks': {
  id: 'mangrove-planks',
  name: 'Mangrove Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'mangrove-log', amount: 1 }]
  }]
},

'cherry-planks': {
  id: 'cherry-planks',
  name: 'Cherry Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'cherry-log', amount: 1 }]
  }]
},

'bamboo-planks': {
  id: 'bamboo-planks',
  name: 'Bamboo Planks',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [{ id: 'bamboo', amount: 2 }]
  }]
},

'crimson-planks': {
  id: 'crimson-planks',
  name: 'Crimson Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'crimson-stem', amount: 1 }]
  }]
},

'warped-planks': {
  id: 'warped-planks',
  name: 'Warped Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'warped-stem', amount: 1 }]
  }]
},

// ==========================================
// WOOD STAIRS (No stonecutter - crafting only)
// ==========================================

'oak-stairs': {
  id: 'oak-stairs',
  name: 'Oak Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'oak-planks', amount: 6 }]
  }]
},

'spruce-stairs': {
  id: 'spruce-stairs',
  name: 'Spruce Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'spruce-planks', amount: 6 }]
  }]
},

'birch-stairs': {
  id: 'birch-stairs',
  name: 'Birch Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'birch-planks', amount: 6 }]
  }]
},

'jungle-stairs': {
  id: 'jungle-stairs',
  name: 'Jungle Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'jungle-planks', amount: 6 }]
  }]
},

'acacia-stairs': {
  id: 'acacia-stairs',
  name: 'Acacia Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'acacia-planks', amount: 6 }]
  }]
},

'dark-oak-stairs': {
  id: 'dark-oak-stairs',
  name: 'Dark Oak Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'dark-oak-planks', amount: 6 }]
  }]
},

'mangrove-stairs': {
  id: 'mangrove-stairs',
  name: 'Mangrove Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'mangrove-planks', amount: 6 }]
  }]
},

'cherry-stairs': {
  id: 'cherry-stairs',
  name: 'Cherry Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'cherry-planks', amount: 6 }]
  }]
},

'bamboo-stairs': {
  id: 'bamboo-stairs',
  name: 'Bamboo Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'bamboo-planks', amount: 6 }]
  }]
},

'crimson-stairs': {
  id: 'crimson-stairs',
  name: 'Crimson Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'crimson-planks', amount: 6 }]
  }]
},

'warped-stairs': {
  id: 'warped-stairs',
  name: 'Warped Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'warped-planks', amount: 6 }]
  }]
},

// ==========================================
// WOOD SLABS (No stonecutter - crafting only)
// ==========================================

'oak-slab': {
  id: 'oak-slab',
  name: 'Oak Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'oak-planks', amount: 3 }]
  }]
},

'spruce-slab': {
  id: 'spruce-slab',
  name: 'Spruce Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'spruce-planks', amount: 3 }]
  }]
},

'birch-slab': {
  id: 'birch-slab',
  name: 'Birch Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'birch-planks', amount: 3 }]
  }]
},

'jungle-slab': {
  id: 'jungle-slab',
  name: 'Jungle Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'jungle-planks', amount: 3 }]
  }]
},

'acacia-slab': {
  id: 'acacia-slab',
  name: 'Acacia Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'acacia-planks', amount: 3 }]
  }]
},

'dark-oak-slab': {
  id: 'dark-oak-slab',
  name: 'Dark Oak Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'dark-oak-planks', amount: 3 }]
  }]
},

'mangrove-slab': {
  id: 'mangrove-slab',
  name: 'Mangrove Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'mangrove-planks', amount: 3 }]
  }]
},

'cherry-slab': {
  id: 'cherry-slab',
  name: 'Cherry Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'cherry-planks', amount: 3 }]
  }]
},

'bamboo-slab': {
  id: 'bamboo-slab',
  name: 'Bamboo Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'bamboo-planks', amount: 3 }]
  }]
},

'crimson-slab': {
  id: 'crimson-slab',
  name: 'Crimson Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'crimson-planks', amount: 3 }]
  }]
},

'warped-slab': {
  id: 'warped-slab',
  name: 'Warped Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'warped-planks', amount: 3 }]
  }]
},

// ==========================================
// WOOD FENCES (crafting only)
// ==========================================

'oak-fence': {
  id: 'oak-fence',
  name: 'Oak Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'oak-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'spruce-fence': {
  id: 'spruce-fence',
  name: 'Spruce Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'spruce-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'birch-fence': {
  id: 'birch-fence',
  name: 'Birch Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'birch-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'jungle-fence': {
  id: 'jungle-fence',
  name: 'Jungle Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'jungle-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'acacia-fence': {
  id: 'acacia-fence',
  name: 'Acacia Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'acacia-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'dark-oak-fence': {
  id: 'dark-oak-fence',
  name: 'Dark Oak Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'dark-oak-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'mangrove-fence': {
  id: 'mangrove-fence',
  name: 'Mangrove Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'mangrove-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'cherry-fence': {
  id: 'cherry-fence',
  name: 'Cherry Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'cherry-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'bamboo-fence': {
  id: 'bamboo-fence',
  name: 'Bamboo Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'bamboo-planks', amount: 4 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'crimson-fence': {
  id: 'crimson-fence',
  name: 'Crimson Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'crimson-planks', amount: 2 },
      { id: 'stick', amount: 4 }
    ]
  }]
},

'warped-fence': {
  id: 'warped-fence',
  name: 'Warped Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'warped-planks', amount: 2 },
      { id: 'stick', amount: 4 }
    ]
  }]
},

'nether-brick-fence': {
  id: 'nether-brick-fence',
  name: 'Nether Brick Fence',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'nether-bricks', amount: 4 },
      { id: 'nether-brick-item', amount: 2 }
    ]
  }]
},

// ==========================================
// FENCE GATES (crafting only)
// ==========================================

'oak-fence-gate': {
  id: 'oak-fence-gate',
  name: 'Oak Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'oak-planks', amount: 2 }
    ]
  }]
},

'spruce-fence-gate': {
  id: 'spruce-fence-gate',
  name: 'Spruce Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'spruce-planks', amount: 2 }
    ]
  }]
},

'birch-fence-gate': {
  id: 'birch-fence-gate',
  name: 'Birch Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'birch-planks', amount: 2 }
    ]
  }]
},

'jungle-fence-gate': {
  id: 'jungle-fence-gate',
  name: 'Jungle Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'jungle-planks', amount: 2 }
    ]
  }]
},

'acacia-fence-gate': {
  id: 'acacia-fence-gate',
  name: 'Acacia Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'acacia-planks', amount: 2 }
    ]
  }]
},

'dark-oak-fence-gate': {
  id: 'dark-oak-fence-gate',
  name: 'Dark Oak Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'dark-oak-planks', amount: 2 }
    ]
  }]
},

'mangrove-fence-gate': {
  id: 'mangrove-fence-gate',
  name: 'Mangrove Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'mangrove-planks', amount: 2 }
    ]
  }]
},

'cherry-fence-gate': {
  id: 'cherry-fence-gate',
  name: 'Cherry Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'cherry-planks', amount: 2 }
    ]
  }]
},

'bamboo-fence-gate': {
  id: 'bamboo-fence-gate',
  name: 'Bamboo Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'bamboo-planks', amount: 2 }
    ]
  }]
},

'crimson-fence-gate': {
  id: 'crimson-fence-gate',
  name: 'Crimson Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'crimson-planks', amount: 2 }
    ]
  }]
},

'warped-fence-gate': {
  id: 'warped-fence-gate',
  name: 'Warped Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 4 },
      { id: 'warped-planks', amount: 2 }
    ]
  }]
},



// ==========================================
// DOORS (crafting only)
// ==========================================

'oak-door': {
  id: 'oak-door',
  name: 'Oak Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'oak-planks', amount: 6 }
    ]
  }]
},

'spruce-door': {
  id: 'spruce-door',
  name: 'Spruce Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'spruce-planks', amount: 6 }
    ]
  }]
},

'birch-door': {
  id: 'birch-door',
  name: 'Birch Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'birch-planks', amount: 6 }
    ]
  }]
},

'jungle-door': {
  id: 'jungle-door',
  name: 'Jungle Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'jungle-planks', amount: 6 }
    ]
  }]
},

'acacia-door': {
  id: 'acacia-door',
  name: 'Acacia Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'acacia-planks', amount: 6 }
    ]
  }]
},

'dark-oak-door': {
  id: 'dark-oak-door',
  name: 'Dark Oak Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'dark-oak-planks', amount: 6 }
    ]
  }]
},

'mangrove-door': {
  id: 'mangrove-door',
  name: 'Mangrove Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'mangrove-planks', amount: 6 }
    ]
  }]
},

'cherry-door': {
  id: 'cherry-door',
  name: 'Cherry Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'cherry-planks', amount: 6 }
    ]
  }]
},

'bamboo-door': {
  id: 'bamboo-door',
  name: 'Bamboo Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'bamboo-planks', amount: 6 }
    ]
  }]
},

'crimson-door': {
  id: 'crimson-door',
  name: 'Crimson Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'crimson-planks', amount: 6 }
    ]
  }]
},

'warped-door': {
  id: 'warped-door',
  name: 'Warped Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'warped-planks', amount: 6 }
    ]
  }]
},

'iron-door': {
  id: 'iron-door',
  name: 'Iron Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'iron-ingot', amount: 6 }
    ]
  }]
},

// ==========================================
// TRAPDOORS (crafting only)
// ==========================================

'oak-trapdoor': {
  id: 'oak-trapdoor',
  name: 'Oak Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'oak-planks', amount: 6 }
    ]
  }]
},

'spruce-trapdoor': {
  id: 'spruce-trapdoor',
  name: 'Spruce Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'spruce-planks', amount: 6 }
    ]
  }]
},

'birch-trapdoor': {
  id: 'birch-trapdoor',
  name: 'Birch Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'birch-planks', amount: 6 }
    ]
  }]
},

'jungle-trapdoor': {
  id: 'jungle-trapdoor',
  name: 'Jungle Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'jungle-planks', amount: 6 }
    ]
  }]
},

'acacia-trapdoor': {
  id: 'acacia-trapdoor',
  name: 'Acacia Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'acacia-planks', amount: 6 }
    ]
  }]
},

'dark-oak-trapdoor': {
  id: 'dark-oak-trapdoor',
  name: 'Dark Oak Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'dark-oak-planks', amount: 6 }
    ]
  }]
},

'mangrove-trapdoor': {
  id: 'mangrove-trapdoor',
  name: 'Mangrove Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'mangrove-planks', amount: 6 }
    ]
  }]
},

'cherry-trapdoor': {
  id: 'cherry-trapdoor',
  name: 'Cherry Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'cherry-planks', amount: 6 }
    ]
  }]
},

'bamboo-trapdoor': {
  id: 'bamboo-trapdoor',
  name: 'Bamboo Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'bamboo-planks', amount: 6 }
    ]
  }]
},

'crimson-trapdoor': {
  id: 'crimson-trapdoor',
  name: 'Crimson Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'crimson-planks', amount: 6 }
    ]
  }]
},

'warped-trapdoor': {
  id: 'warped-trapdoor',
  name: 'Warped Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'warped-planks', amount: 6 }
    ]
  }]
},

'iron-trapdoor': {
  id: 'iron-trapdoor',
  name: 'Iron Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 4 }
    ]
  }]
},

// ==========================================
// BUTTONS (crafting only)
// ==========================================

'oak-button': {
  id: 'oak-button',
  name: 'Oak Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'oak-planks', amount: 1 }
    ]
  }]
},

'spruce-button': {
  id: 'spruce-button',
  name: 'Spruce Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'spruce-planks', amount: 1 }
    ]
  }]
},

'birch-button': {
  id: 'birch-button',
  name: 'Birch Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'birch-planks', amount: 1 }
    ]
  }]
},

'jungle-button': {
  id: 'jungle-button',
  name: 'Jungle Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'jungle-planks', amount: 1 }
    ]
  }]
},

'acacia-button': {
  id: 'acacia-button',
  name: 'Acacia Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'acacia-planks', amount: 1 }
    ]
  }]
},

'dark-oak-button': {
  id: 'dark-oak-button',
  name: 'Dark Oak Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'dark-oak-planks', amount: 1 }
    ]
  }]
},

'mangrove-button': {
  id: 'mangrove-button',
  name: 'Mangrove Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'mangrove-planks', amount: 1 }
    ]
  }]
},

'cherry-button': {
  id: 'cherry-button',
  name: 'Cherry Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cherry-planks', amount: 1 }
    ]
  }]
},

'bamboo-button': {
  id: 'bamboo-button',
  name: 'Bamboo Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bamboo-planks', amount: 1 }
    ]
  }]
},

'crimson-button': {
  id: 'crimson-button',
  name: 'Crimson Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'crimson-planks', amount: 1 }
    ]
  }]
},

'warped-button': {
  id: 'warped-button',
  name: 'Warped Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'warped-planks', amount: 1 }
    ]
  }]
},

'stone-button': {
  id: 'stone-button',
  name: 'Stone Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stone', amount: 1 }
    ]
  }]
},

'stone-button': {
  id: 'stone-button',
  name: 'Stone Button',
  recipes: [
    { method: 'crafting_table', output: 1, ingredients: [{ id: 'stone', amount: 1 }] },
    { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'stone', amount: 1 }] }
  ]
},

'polished-blackstone-button': {
  id: 'polished-blackstone-button',
  name: 'Polished Blackstone Button',
  recipes: [
    { method: 'crafting_table', output: 1, ingredients: [{ id: 'polished-blackstone', amount: 1 }] },
    { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'polished-blackstone', amount: 1 }] }
  ]
},

// ==========================================
// PRESSURE PLATES (2 Blocks = 1 Plate)
// ==========================================

'stone-pressure-plate': {
  id: 'stone-pressure-plate',
  name: 'Stone Pressure Plate',
  recipes: [
    { method: 'crafting_table', output: 1, ingredients: [{ id: 'stone', amount: 2 }] },
    { method: 'stonecutter', output: 1, priority: true, ingredients: [{ id: 'stone', amount: 1 }] } 
    // Note: Stonecutter is 1:1 for plates, making it 50% cheaper than crafting!
  ]
},

// ==========================================
// WEIGHTED PRESSURE PLATES (Metals)
// ==========================================

'light-weighted-pressure-plate': {
  id: 'light-weighted-pressure-plate',
  name: 'Gold Pressure Plate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'gold-ingot', amount: 2 }]
  }]
},

'heavy-weighted-pressure-plate': {
  id: 'heavy-weighted-pressure-plate',
  name: 'Iron Pressure Plate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'iron-ingot', amount: 2 }]
  }]
},





// ==========================================
// STONE CATEGORY (HAS STONECUTTER)
// ==========================================

// Stone Bricks (crafted from stone)
'stone-bricks': {
  id: 'stone-bricks',
  name: 'Stone Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'stone', amount: 4 }
    ]
  }]
},

// Smooth Stone (smelted)
'smooth-stone': {
  id: 'smooth-stone',
  name: 'Smooth Stone',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [
      { id: 'stone', amount: 1 }
    ]
  }]
},

// Mossy Cobblestone (crafted with vines)
'mossy-cobblestone': {
  id: 'mossy-cobblestone',
  name: 'Mossy Cobblestone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cobblestone', amount: 1 },
      { id: 'vines', amount: 1 }
    ]
  }]
},

// Mossy Stone Bricks (crafted with vines)
'mossy-stone-bricks': {
  id: 'mossy-stone-bricks',
  name: 'Mossy Stone Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stone-bricks', amount: 1 },
      { id: 'vines', amount: 1 }
    ]
  }]
},

// ==========================================
// STONE STAIRS - DUAL RECIPES
// ==========================================

'stone-stairs': {
  id: 'stone-stairs',
  name: 'Stone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'stone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'stone', amount: 1 }]
    }
  ]
},

'cobblestone-stairs': {
  id: 'cobblestone-stairs',
  name: 'Cobblestone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'cobblestone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobblestone', amount: 1 }]
    }
  ]
},

'stone-brick-stairs': {
  id: 'stone-brick-stairs',
  name: 'Stone Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'stone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'stone-bricks', amount: 1 }]
    }
  ]
},

'mossy-cobblestone-stairs': {
  id: 'mossy-cobblestone-stairs',
  name: 'Mossy Cobblestone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'mossy-cobblestone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'mossy-cobblestone', amount: 1 }]
    }
  ]
},

'mossy-stone-brick-stairs': {
  id: 'mossy-stone-brick-stairs',
  name: 'Mossy Stone Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'mossy-stone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'mossy-stone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// STONE SLABS - DUAL RECIPES
// ==========================================

'stone-slab': {
  id: 'stone-slab',
  name: 'Stone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'stone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'stone', amount: 1 }]
    }
  ]
},

'cobblestone-slab': {
  id: 'cobblestone-slab',
  name: 'Cobblestone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cobblestone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'cobblestone', amount: 1 }]
    }
  ]
},

'stone-brick-slab': {
  id: 'stone-brick-slab',
  name: 'Stone Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'stone-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'stone-bricks', amount: 1 }]
    }
  ]
},

'smooth-stone-slab': {
  id: 'smooth-stone-slab',
  name: 'Smooth Stone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'smooth-stone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'smooth-stone', amount: 1 }]
    }
  ]
},

'mossy-cobblestone-slab': {
  id: 'mossy-cobblestone-slab',
  name: 'Mossy Cobblestone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'mossy-cobblestone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'mossy-cobblestone', amount: 1 }]
    }
  ]
},

'mossy-stone-brick-slab': {
  id: 'mossy-stone-brick-slab',
  name: 'Mossy Stone Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'mossy-stone-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'mossy-stone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// STONE WALLS - DUAL RECIPES
// ==========================================

'cobblestone-wall': {
  id: 'cobblestone-wall',
  name: 'Cobblestone Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cobblestone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobblestone', amount: 1 }]
    }
  ]
},

'mossy-cobblestone-wall': {
  id: 'mossy-cobblestone-wall',
  name: 'Mossy Cobblestone Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'mossy-cobblestone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'mossy-cobblestone', amount: 1 }]
    }
  ]
},

'stone-brick-wall': {
  id: 'stone-brick-wall',
  name: 'Stone Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'stone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'stone-bricks', amount: 1 }]
    }
  ]
},

'mossy-stone-brick-wall': {
  id: 'mossy-stone-brick-wall',
  name: 'Mossy Stone Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'mossy-stone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'mossy-stone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// POLISHED VARIANTS (crafted)
// ==========================================

'polished-granite': {
  id: 'polished-granite',
  name: 'Polished Granite',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'granite', amount: 4 }
    ]
  }]
},

'polished-diorite': {
  id: 'polished-diorite',
  name: 'Polished Diorite',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'diorite', amount: 4 }
    ]
  }]
},

'polished-andesite': {
  id: 'polished-andesite',
  name: 'Polished Andesite',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'andesite', amount: 4 }
    ]
  }]
},

// ==========================================
// GRANITE STAIRS - DUAL RECIPES
// ==========================================

'granite-stairs': {
  id: 'granite-stairs',
  name: 'Granite Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'granite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'granite', amount: 1 }]
    }
  ]
},

'polished-granite-stairs': {
  id: 'polished-granite-stairs',
  name: 'Polished Granite Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-granite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-granite', amount: 1 }]
    }
  ]
},

// ==========================================
// DIORITE STAIRS - DUAL RECIPES
// ==========================================

'diorite-stairs': {
  id: 'diorite-stairs',
  name: 'Diorite Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'diorite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'diorite', amount: 1 }]
    }
  ]
},

'polished-diorite-stairs': {
  id: 'polished-diorite-stairs',
  name: 'Polished Diorite Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-diorite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-diorite', amount: 1 }]
    }
  ]
},

// ==========================================
// ANDESITE STAIRS - DUAL RECIPES
// ==========================================

'andesite-stairs': {
  id: 'andesite-stairs',
  name: 'Andesite Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'andesite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'andesite', amount: 1 }]
    }
  ]
},

'polished-andesite-stairs': {
  id: 'polished-andesite-stairs',
  name: 'Polished Andesite Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-andesite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-andesite', amount: 1 }]
    }
  ]
},

// ==========================================
// GRANITE SLABS - DUAL RECIPES
// ==========================================

'granite-slab': {
  id: 'granite-slab',
  name: 'Granite Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'granite', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'granite', amount: 1 }]
    }
  ]
},

'polished-granite-slab': {
  id: 'polished-granite-slab',
  name: 'Polished Granite Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-granite', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-granite', amount: 1 }]
    }
  ]
},

// ==========================================
// DIORITE SLABS - DUAL RECIPES
// ==========================================

'diorite-slab': {
  id: 'diorite-slab',
  name: 'Diorite Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'diorite', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'diorite', amount: 1 }]
    }
  ]
},

'polished-diorite-slab': {
  id: 'polished-diorite-slab',
  name: 'Polished Diorite Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-diorite', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-diorite', amount: 1 }]
    }
  ]
},

// ==========================================
// ANDESITE SLABS - DUAL RECIPES
// ==========================================

'andesite-slab': {
  id: 'andesite-slab',
  name: 'Andesite Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'andesite', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'andesite', amount: 1 }]
    }
  ]
},

'polished-andesite-slab': {
  id: 'polished-andesite-slab',
  name: 'Polished Andesite Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-andesite', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-andesite', amount: 1 }]
    }
  ]
},

// ==========================================
// GRANITE WALLS - DUAL RECIPES
// ==========================================

'granite-wall': {
  id: 'granite-wall',
  name: 'Granite Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'granite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'granite', amount: 1 }]
    }
  ]
},

// ==========================================
// DIORITE WALLS - DUAL RECIPES
// ==========================================

'diorite-wall': {
  id: 'diorite-wall',
  name: 'Diorite Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'diorite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'diorite', amount: 1 }]
    }
  ]
},

// ==========================================
// ANDESITE WALLS - DUAL RECIPES
// ==========================================

'andesite-wall': {
  id: 'andesite-wall',
  name: 'Andesite Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'andesite', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'andesite', amount: 1 }]
    }
  ]
},

// ==========================================
// DEEPSLATE VARIANTS (crafted/smelted)
// ==========================================

'polished-deepslate': {
  id: 'polished-deepslate',
  name: 'Polished Deepslate',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'cobbled-deepslate', amount: 4 }
    ]
  }]
},

'deepslate-bricks': {
  id: 'deepslate-bricks',
  name: 'Deepslate Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'polished-deepslate', amount: 4 }
    ]
  }]
},

'deepslate-tiles': {
  id: 'deepslate-tiles',
  name: 'Deepslate Tiles',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'deepslate-bricks', amount: 4 }
    ]
  }]
},

// ==========================================
// COBBLED DEEPSLATE STAIRS - DUAL RECIPES
// ==========================================

'cobbled-deepslate-stairs': {
  id: 'cobbled-deepslate-stairs',
  name: 'Cobbled Deepslate Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'cobbled-deepslate', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobbled-deepslate', amount: 1 }]
    }
  ]
},

'polished-deepslate-stairs': {
  id: 'polished-deepslate-stairs',
  name: 'Polished Deepslate Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-deepslate', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-deepslate', amount: 1 }]
    }
  ]
},

'deepslate-brick-stairs': {
  id: 'deepslate-brick-stairs',
  name: 'Deepslate Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'deepslate-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'deepslate-bricks', amount: 1 }]
    }
  ]
},

'deepslate-tile-stairs': {
  id: 'deepslate-tile-stairs',
  name: 'Deepslate Tile Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'deepslate-tiles', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'deepslate-tiles', amount: 1 }]
    }
  ]
},

// ==========================================
// DEEPSLATE SLABS - DUAL RECIPES
// ==========================================

'cobbled-deepslate-slab': {
  id: 'cobbled-deepslate-slab',
  name: 'Cobbled Deepslate Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cobbled-deepslate', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'cobbled-deepslate', amount: 1 }]
    }
  ]
},

'polished-deepslate-slab': {
  id: 'polished-deepslate-slab',
  name: 'Polished Deepslate Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-deepslate', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-deepslate', amount: 1 }]
    }
  ]
},

'deepslate-brick-slab': {
  id: 'deepslate-brick-slab',
  name: 'Deepslate Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'deepslate-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'deepslate-bricks', amount: 1 }]
    }
  ]
},

'deepslate-tile-slab': {
  id: 'deepslate-tile-slab',
  name: 'Deepslate Tile Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'deepslate-tiles', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'deepslate-tiles', amount: 1 }]
    }
  ]
},

// ==========================================
// DEEPSLATE WALLS - DUAL RECIPES
// ==========================================

'cobbled-deepslate-wall': {
  id: 'cobbled-deepslate-wall',
  name: 'Cobbled Deepslate Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cobbled-deepslate', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobbled-deepslate', amount: 1 }]
    }
  ]
},

'polished-deepslate-wall': {
  id: 'polished-deepslate-wall',
  name: 'Polished Deepslate Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-deepslate', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-deepslate', amount: 1 }]
    }
  ]
},

'deepslate-brick-wall': {
  id: 'deepslate-brick-wall',
  name: 'Deepslate Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'deepslate-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'deepslate-bricks', amount: 1 }]
    }
  ]
},

'deepslate-tile-wall': {
  id: 'deepslate-tile-wall',
  name: 'Deepslate Tile Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'deepslate-tiles', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'deepslate-tiles', amount: 1 }]
    }
  ]
},


'mossy-stone-bricks': {
  id: 'mossy-stone-bricks',
  name: 'Mossy Stone Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [
        { id: 'stone-bricks', amount: 1 },
        { id: 'vines', amount: 1 }
      ]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [
        { id: 'mossy-cobblestone', amount: 1 }
      ]
    }
  ]
},

// Add these recipes - stonecutter can skip steps!
'deepslate-bricks': {
  id: 'deepslate-bricks',
  name: 'Deepslate Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-deepslate', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobbled-deepslate', amount: 1 }]  // Skip polished!
    }
  ]
},

'deepslate-tiles': {
  id: 'deepslate-tiles',
  name: 'Deepslate Tiles',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'deepslate-bricks', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobbled-deepslate', amount: 1 }]  // Skip bricks!
    }
  ]
},

'chiseled-stone-bricks': {
  id: 'chiseled-stone-bricks',
  name: 'Chiseled Stone Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'stone-brick-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'stone-bricks', amount: 1 }]
    }
  ]
},

'chiseled-deepslate': {
  id: 'chiseled-deepslate',
  name: 'Chiseled Deepslate',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'cobbled-deepslate-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cobbled-deepslate', amount: 1 }]
    }
  ]
},

'chiseled-polished-blackstone': {
  id: 'chiseled-polished-blackstone',
  name: 'Chiseled Polished Blackstone',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'polished-blackstone-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-blackstone', amount: 1 }]
    }
  ]
},

'chiseled-sandstone': {
  id: 'chiseled-sandstone',
  name: 'Chiseled Sandstone',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'sandstone-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'sandstone', amount: 1 }]  // Direct from sandstone!
    }
  ]
},

'chiseled-red-sandstone': {
  id: 'chiseled-red-sandstone',
  name: 'Chiseled Red Sandstone',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'red-sandstone-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'red-sandstone', amount: 1 }]  // Direct from red sandstone!
    }
  ]
},

'chiseled-quartz-block': {
  id: 'chiseled-quartz-block',
  name: 'Chiseled Quartz Block',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'quartz-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'quartz-block', amount: 1 }]
    }
  ]
},


// ==========================================
// SANDSTONE VARIANTS (crafted)
// ==========================================

'sandstone': {
  id: 'sandstone',
  name: 'Sandstone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'sand', amount: 4 }
    ]
  }]
},

'smooth-sandstone': {
  id: 'smooth-sandstone',
  name: 'Smooth Sandstone',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [
      { id: 'sandstone', amount: 1 }
    ]
  }]
},

'cut-sandstone': {
  id: 'cut-sandstone',
  name: 'Cut Sandstone',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'sandstone', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'sandstone', amount: 1 }]
    }
  ]
},

'red-sandstone': {
  id: 'red-sandstone',
  name: 'Red Sandstone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'red-sand', amount: 4 }
    ]
  }]
},

'smooth-red-sandstone': {
  id: 'smooth-red-sandstone',
  name: 'Smooth Red Sandstone',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [
      { id: 'red-sandstone', amount: 1 }
    ]
  }]
},

'cut-red-sandstone': {
  id: 'cut-red-sandstone',
  name: 'Cut Red Sandstone',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'red-sandstone', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'red-sandstone', amount: 1 }]
    }
  ]
},

// ==========================================
// SANDSTONE STAIRS - DUAL RECIPES
// ==========================================

'sandstone-stairs': {
  id: 'sandstone-stairs',
  name: 'Sandstone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'sandstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'sandstone', amount: 1 }]
    }
  ]
},

'smooth-sandstone-stairs': {
  id: 'smooth-sandstone-stairs',
  name: 'Smooth Sandstone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'smooth-sandstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'smooth-sandstone', amount: 1 }]
    }
  ]
},

'red-sandstone-stairs': {
  id: 'red-sandstone-stairs',
  name: 'Red Sandstone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'red-sandstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'red-sandstone', amount: 1 }]
    }
  ]
},

'smooth-red-sandstone-stairs': {
  id: 'smooth-red-sandstone-stairs',
  name: 'Smooth Red Sandstone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'smooth-red-sandstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'smooth-red-sandstone', amount: 1 }]
    }
  ]
},

// ==========================================
// SANDSTONE SLABS - DUAL RECIPES
// ==========================================

'sandstone-slab': {
  id: 'sandstone-slab',
  name: 'Sandstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'sandstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'sandstone', amount: 1 }]
    }
  ]
},

'smooth-sandstone-slab': {
  id: 'smooth-sandstone-slab',
  name: 'Smooth Sandstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'smooth-sandstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'smooth-sandstone', amount: 1 }]
    }
  ]
},

'cut-sandstone-slab': {
  id: 'cut-sandstone-slab',
  name: 'Cut Sandstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cut-sandstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'cut-sandstone', amount: 1 }]
    }
  ]
},

'red-sandstone-slab': {
  id: 'red-sandstone-slab',
  name: 'Red Sandstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'red-sandstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'red-sandstone', amount: 1 }]
    }
  ]
},

'smooth-red-sandstone-slab': {
  id: 'smooth-red-sandstone-slab',
  name: 'Smooth Red Sandstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'smooth-red-sandstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'smooth-red-sandstone', amount: 1 }]
    }
  ]
},

'cut-red-sandstone-slab': {
  id: 'cut-red-sandstone-slab',
  name: 'Cut Red Sandstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cut-red-sandstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'cut-red-sandstone', amount: 1 }]
    }
  ]
},

// ==========================================
// SANDSTONE WALLS - DUAL RECIPES
// ==========================================

'sandstone-wall': {
  id: 'sandstone-wall',
  name: 'Sandstone Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'sandstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'sandstone', amount: 1 }]
    }
  ]
},

'red-sandstone-wall': {
  id: 'red-sandstone-wall',
  name: 'Red Sandstone Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'red-sandstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'red-sandstone', amount: 1 }]
    }
  ]
},

// ==========================================
// PRISMARINE BLOCKS (crafted)
// ==========================================

'prismarine': {
  id: 'prismarine',
  name: 'Prismarine',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'prismarine-shard', amount: 4 }
    ]
  }]
},

'prismarine-bricks': {
  id: 'prismarine-bricks',
  name: 'Prismarine Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'prismarine-shard', amount: 9 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'prismarine', amount: 1 }]  // Skip shards!
    }
  ]
},

'dark-prismarine': {
  id: 'dark-prismarine',
  name: 'Dark Prismarine',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [
        { id: 'prismarine-shard', amount: 8 },
        { id: 'black-dye', amount: 1 }
      ]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'prismarine', amount: 1 }]  // Skip shards + dye!
    }
  ]
},

'sea-lantern': {
  id: 'sea-lantern',
  name: 'Sea Lantern',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'prismarine-shard', amount: 4 },
      { id: 'prismarine-crystals', amount: 5 }
    ]
  }]
},

// ==========================================
// PRISMARINE STAIRS - DUAL RECIPES
// ==========================================

'prismarine-stairs': {
  id: 'prismarine-stairs',
  name: 'Prismarine Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'prismarine', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'prismarine', amount: 1 }]
    }
  ]
},

'prismarine-brick-stairs': {
  id: 'prismarine-brick-stairs',
  name: 'Prismarine Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'prismarine-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'prismarine-bricks', amount: 1 }]
    }
  ]
},

'dark-prismarine-stairs': {
  id: 'dark-prismarine-stairs',
  name: 'Dark Prismarine Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'dark-prismarine', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'dark-prismarine', amount: 1 }]
    }
  ]
},

// ==========================================
// PRISMARINE SLABS - DUAL RECIPES
// ==========================================

'prismarine-slab': {
  id: 'prismarine-slab',
  name: 'Prismarine Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'prismarine', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'prismarine', amount: 1 }]
    }
  ]
},

'prismarine-brick-slab': {
  id: 'prismarine-brick-slab',
  name: 'Prismarine Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'prismarine-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'prismarine-bricks', amount: 1 }]
    }
  ]
},

'dark-prismarine-slab': {
  id: 'dark-prismarine-slab',
  name: 'Dark Prismarine Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'dark-prismarine', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'dark-prismarine', amount: 1 }]
    }
  ]
},

// ==========================================
// PRISMARINE WALL
// ==========================================

'prismarine-wall': {
  id: 'prismarine-wall',
  name: 'Prismarine Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'prismarine', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'prismarine', amount: 1 }]
    }
  ]
},

'prismarine-brick-wall': {
  id: 'prismarine-brick-wall',
  name: 'Prismarine Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'prismarine-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'prismarine-bricks', amount: 1 }]
    }
  ]
},

'dark-prismarine-wall': {
  id: 'dark-prismarine-wall',
  name: 'Dark Prismarine Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'dark-prismarine', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'dark-prismarine', amount: 1 }]
    }
  ]
},

// ==========================================
// BLACKSTONE VARIANTS (crafted)
// ==========================================

'polished-blackstone': {
  id: 'polished-blackstone',
  name: 'Polished Blackstone',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'blackstone', amount: 4 }
    ]
  }]
},

'polished-blackstone-bricks': {
  id: 'polished-blackstone-bricks',
  name: 'Polished Blackstone Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-blackstone', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'blackstone', amount: 1 }]  // Skip polished!
    }
  ]
},

'chiseled-polished-blackstone': {
  id: 'chiseled-polished-blackstone',
  name: 'Chiseled Polished Blackstone',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'polished-blackstone-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-blackstone', amount: 1 }]
    }
  ]
},



// ==========================================
// BLACKSTONE STAIRS - DUAL RECIPES
// ==========================================

'blackstone-stairs': {
  id: 'blackstone-stairs',
  name: 'Blackstone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'blackstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'blackstone', amount: 1 }]
    }
  ]
},

'polished-blackstone-stairs': {
  id: 'polished-blackstone-stairs',
  name: 'Polished Blackstone Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-blackstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-blackstone', amount: 1 }]
    }
  ]
},

'polished-blackstone-brick-stairs': {
  id: 'polished-blackstone-brick-stairs',
  name: 'Polished Blackstone Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-blackstone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-blackstone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// BLACKSTONE SLABS - DUAL RECIPES
// ==========================================

'blackstone-slab': {
  id: 'blackstone-slab',
  name: 'Blackstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'blackstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'blackstone', amount: 1 }]
    }
  ]
},

'polished-blackstone-slab': {
  id: 'polished-blackstone-slab',
  name: 'Polished Blackstone Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-blackstone', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-blackstone', amount: 1 }]
    }
  ]
},

'polished-blackstone-brick-slab': {
  id: 'polished-blackstone-brick-slab',
  name: 'Polished Blackstone Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-blackstone-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-blackstone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// BLACKSTONE WALLS - DUAL RECIPES
// ==========================================

'blackstone-wall': {
  id: 'blackstone-wall',
  name: 'Blackstone Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'blackstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'blackstone', amount: 1 }]
    }
  ]
},

'polished-blackstone-wall': {
  id: 'polished-blackstone-wall',
  name: 'Polished Blackstone Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-blackstone', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-blackstone', amount: 1 }]
    }
  ]
},

'polished-blackstone-brick-wall': {
  id: 'polished-blackstone-brick-wall',
  name: 'Polished Blackstone Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-blackstone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-blackstone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// NETHER BRICK BLOCKS (crafted/smelted)
// ==========================================

'nether-bricks': {
  id: 'nether-bricks',
  name: 'Nether Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'nether-brick-item', amount: 4 }
    ]
  }]
},

'red-nether-bricks': {
  id: 'red-nether-bricks',
  name: 'Red Nether Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'nether-brick-item', amount: 2 },
      { id: 'nether-wart', amount: 2 }
    ]
  }]
},

'chiseled-nether-bricks': {
  id: 'chiseled-nether-bricks',
  name: 'Chiseled Nether Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'nether-brick-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'nether-bricks', amount: 1 }]
    }
  ]
},

'cracked-nether-bricks': {
  id: 'cracked-nether-bricks',
  name: 'Cracked Nether Bricks',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [
      { id: 'nether-bricks', amount: 1 }
    ]
  }]
},

// ==========================================
// END STONE BLOCKS (crafted)
// ==========================================

'end-stone-bricks': {
  id: 'end-stone-bricks',
  name: 'End Stone Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'end-stone', amount: 4 }
    ]
  }]
},

// ==========================================
// NETHER BRICK STAIRS - DUAL RECIPES
// ==========================================

'nether-brick-stairs': {
  id: 'nether-brick-stairs',
  name: 'Nether Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'nether-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'nether-bricks', amount: 1 }]
    }
  ]
},

'red-nether-brick-stairs': {
  id: 'red-nether-brick-stairs',
  name: 'Red Nether Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'red-nether-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'red-nether-bricks', amount: 1 }]
    }
  ]
},

'end-stone-brick-stairs': {
  id: 'end-stone-brick-stairs',
  name: 'End Stone Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'end-stone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'end-stone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// NETHER BRICK SLABS - DUAL RECIPES
// ==========================================

'nether-brick-slab': {
  id: 'nether-brick-slab',
  name: 'Nether Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'nether-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'nether-bricks', amount: 1 }]
    }
  ]
},

'red-nether-brick-slab': {
  id: 'red-nether-brick-slab',
  name: 'Red Nether Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'red-nether-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'red-nether-bricks', amount: 1 }]
    }
  ]
},

'end-stone-brick-slab': {
  id: 'end-stone-brick-slab',
  name: 'End Stone Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'end-stone-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'end-stone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// NETHER BRICK WALLS - DUAL RECIPES
// ==========================================

'nether-brick-wall': {
  id: 'nether-brick-wall',
  name: 'Nether Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'nether-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'nether-bricks', amount: 1 }]
    }
  ]
},

'red-nether-brick-wall': {
  id: 'red-nether-brick-wall',
  name: 'Red Nether Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'red-nether-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'red-nether-bricks', amount: 1 }]
    }
  ]
},

'end-stone-brick-wall': {
  id: 'end-stone-brick-wall',
  name: 'End Stone Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'end-stone-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'end-stone-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// BRICK BLOCKS (crafted)
// ==========================================

'bricks': {
  id: 'bricks',
  name: 'Bricks',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'brick', amount: 4 }
    ]
  }]
},

'packed-mud': {
  id: 'packed-mud',
  name: 'Packed Mud',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'mud', amount: 1 },
      { id: 'wheat', amount: 1 }
    ]
  }]
},

'mud-bricks': {
  id: 'mud-bricks',
  name: 'Mud Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'packed-mud', amount: 4 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'packed-mud', amount: 1 }]
    }
  ]
},

// ==========================================
// BRICK STAIRS - DUAL RECIPES
// ==========================================

'brick-stairs': {
  id: 'brick-stairs',
  name: 'Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'bricks', amount: 1 }]
    }
  ]
},

'mud-brick-stairs': {
  id: 'mud-brick-stairs',
  name: 'Mud Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'mud-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'mud-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// BRICK SLABS - DUAL RECIPES
// ==========================================

'brick-slab': {
  id: 'brick-slab',
  name: 'Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'bricks', amount: 1 }]
    }
  ]
},

'mud-brick-slab': {
  id: 'mud-brick-slab',
  name: 'Mud Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'mud-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'mud-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// BRICK WALLS - DUAL RECIPES
// ==========================================

'brick-wall': {
  id: 'brick-wall',
  name: 'Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'bricks', amount: 1 }]
    }
  ]
},

'mud-brick-wall': {
  id: 'mud-brick-wall',
  name: 'Mud Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'mud-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'mud-bricks', amount: 1 }]
    }
  ]
},

// ==========================================
// PURPUR BLOCKS (crafted/smelted)
// ==========================================

'popped-chorus-fruit': {
  id: 'popped-chorus-fruit',
  name: 'Popped Chorus Fruit',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'chorus-fruit', amount: 1 }]
  }]
},

'purpur-block': {
  id: 'purpur-block',
  name: 'Purpur Block',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'popped-chorus-fruit', amount: 4 }
    ]
  }]
},

'purpur-pillar': {
  id: 'purpur-pillar',
  name: 'Purpur Pillar',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'purpur-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'purpur-block', amount: 1 }]
    }
  ]
},

// ==========================================
// QUARTZ BLOCKS (crafted/smelted)
// ==========================================

'quartz-block': {
  id: 'quartz-block',
  name: 'Block of Quartz',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'nether-quartz', amount: 4 }
    ]
  }]
},

'quartz-bricks': {
  id: 'quartz-bricks',
  name: 'Quartz Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'quartz-block', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'quartz-block', amount: 1 }]
    }
  ]
},

'quartz-pillar': {
  id: 'quartz-pillar',
  name: 'Quartz Pillar',
  recipes: [
    {
      method: 'crafting_table',
      output: 2,
      ingredients: [{ id: 'quartz-block', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'quartz-block', amount: 1 }]
    }
  ]
},

'smooth-quartz-block': {
  id: 'smooth-quartz-block',
  name: 'Smooth Quartz Block',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'quartz-block', amount: 1 }]
  }]
},

'chiseled-quartz-block': {
  id: 'chiseled-quartz-block',
  name: 'Chiseled Quartz Block',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'quartz-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'quartz-block', amount: 1 }]
    }
  ]
},

// ==========================================
// PURPUR STAIRS - DUAL RECIPES
// ==========================================

'purpur-stairs': {
  id: 'purpur-stairs',
  name: 'Purpur Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'purpur-block', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'purpur-block', amount: 1 }]
    }
  ]
},

// ==========================================
// QUARTZ STAIRS - DUAL RECIPES
// ==========================================

'quartz-stairs': {
  id: 'quartz-stairs',
  name: 'Quartz Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'quartz-block', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'quartz-block', amount: 1 }]
    }
  ]
},

'smooth-quartz-stairs': {
  id: 'smooth-quartz-stairs',
  name: 'Smooth Quartz Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'smooth-quartz', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'smooth-quartz', amount: 1 }]
    }
  ]
},

// ==========================================
// PURPUR SLABS - DUAL RECIPES
// ==========================================

'purpur-slab': {
  id: 'purpur-slab',
  name: 'Purpur Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'purpur-block', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'purpur-block', amount: 1 }]
    }
  ]
},

// ==========================================
// QUARTZ SLABS - DUAL RECIPES
// ==========================================

'quartz-slab': {
  id: 'quartz-slab',
  name: 'Quartz Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'quartz-block', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'quartz-block', amount: 1 }]
    }
  ]
},

'smooth-quartz-slab': {
  id: 'smooth-quartz-slab',
  name: 'Smooth Quartz Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'smooth-quartz-block', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'smooth-quartz-block', amount: 1 }]
    }
  ]
},

// ==========================================
// COPPER SMELTING
// ==========================================

'copper-ingot': {
  id: 'copper-ingot',
  name: 'Copper Ingot',
  recipes: [
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'raw-copper', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'copper-ore', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'deepslate-copper-ore', amount: 1 }]
    }
  ]
},

// ==========================================
// COPPER BLOCKS (crafted)
// ==========================================

'copper-block': {
  id: 'copper-block',
  name: 'Block of Copper',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'copper-ingot', amount: 9 }]
  }]
},

'cut-copper': {
  id: 'cut-copper',
  name: 'Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'copper-block', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'copper-block', amount: 1 }]
    }
  ]
},

// ==========================================
// EXPOSED COPPER (oxidation - not craftable)
// ==========================================


'exposed-cut-copper': {
  id: 'exposed-cut-copper',
  name: 'Exposed Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'exposed-copper', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'exposed-copper', amount: 1 }]
    }
  ]
},

// ==========================================
// WEATHERED COPPER (oxidation - not craftable)
// ==========================================



'weathered-cut-copper': {
  id: 'weathered-cut-copper',
  name: 'Weathered Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'weathered-copper', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'weathered-copper', amount: 1 }]
    }
  ]
},

// ==========================================
// OXIDIZED COPPER (oxidation - not craftable)
// ==========================================



'oxidized-cut-copper': {
  id: 'oxidized-cut-copper',
  name: 'Oxidized Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'oxidized-copper', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'oxidized-copper', amount: 1 }]
    }
  ]
},

// ==========================================
// COPPER STAIRS - DUAL RECIPES (all stages)
// ==========================================

'cut-copper-stairs': {
  id: 'cut-copper-stairs',
  name: 'Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'cut-copper', amount: 1 }]
    }
  ]
},

'exposed-cut-copper-stairs': {
  id: 'exposed-cut-copper-stairs',
  name: 'Exposed Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'exposed-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'exposed-cut-copper', amount: 1 }]
    }
  ]
},

'weathered-cut-copper-stairs': {
  id: 'weathered-cut-copper-stairs',
  name: 'Weathered Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'weathered-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'weathered-cut-copper', amount: 1 }]
    }
  ]
},

'oxidized-cut-copper-stairs': {
  id: 'oxidized-cut-copper-stairs',
  name: 'Oxidized Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'oxidized-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'oxidized-cut-copper', amount: 1 }]
    }
  ]
},

// ==========================================
// COPPER SLABS - DUAL RECIPES (all stages)
// ==========================================

'cut-copper-slab': {
  id: 'cut-copper-slab',
  name: 'Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'cut-copper', amount: 1 }]
    }
  ]
},

'exposed-cut-copper-slab': {
  id: 'exposed-cut-copper-slab',
  name: 'Exposed Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'exposed-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'exposed-cut-copper', amount: 1 }]
    }
  ]
},

'weathered-cut-copper-slab': {
  id: 'weathered-cut-copper-slab',
  name: 'Weathered Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'weathered-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'weathered-cut-copper', amount: 1 }]
    }
  ]
},

'oxidized-cut-copper-slab': {
  id: 'oxidized-cut-copper-slab',
  name: 'Oxidized Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'oxidized-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'oxidized-cut-copper', amount: 1 }]
    }
  ]
},

// ==========================================
// WAXED COPPER BLOCKS (interaction with honeycomb)
// ==========================================

'waxed-copper-block': {
  id: 'waxed-copper-block',
  name: 'Waxed Block of Copper',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'copper-block', amount: 1 }]
  }]
},

'waxed-cut-copper': {
  id: 'waxed-cut-copper',
  name: 'Waxed Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-copper-block', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-copper-block', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'cut-copper', amount: 1 }]
    }
  ]
},

'waxed-exposed-copper': {
  id: 'waxed-exposed-copper',
  name: 'Waxed Exposed Copper',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'exposed-copper', amount: 1 }]
  }]
},

'waxed-exposed-cut-copper': {
  id: 'waxed-exposed-cut-copper',
  name: 'Waxed Exposed Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-exposed-copper', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-exposed-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'exposed-cut-copper', amount: 1 }]
    }
  ]
},

'waxed-weathered-copper': {
  id: 'waxed-weathered-copper',
  name: 'Waxed Weathered Copper',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'weathered-copper', amount: 1 }]
  }]
},

'waxed-weathered-cut-copper': {
  id: 'waxed-weathered-cut-copper',
  name: 'Waxed Weathered Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-weathered-copper', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-weathered-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'weathered-cut-copper', amount: 1 }]
    }
  ]
},

'waxed-oxidized-copper': {
  id: 'waxed-oxidized-copper',
  name: 'Waxed Oxidized Copper',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'oxidized-copper', amount: 1 }]
  }]
},

'waxed-oxidized-cut-copper': {
  id: 'waxed-oxidized-cut-copper',
  name: 'Waxed Oxidized Cut Copper',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-oxidized-copper', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-oxidized-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'weathered-cut-copper', amount: 1 }]
    }
  ]
},

// ==========================================
// WAXED COPPER STAIRS
// ==========================================

'waxed-cut-copper-stairs': {
  id: 'waxed-cut-copper-stairs',
  name: 'Waxed Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'cut-copper-stairs', amount: 1 }]
    }
  ]
},

'waxed-exposed-cut-copper-stairs': {
  id: 'waxed-exposed-cut-copper-stairs',
  name: 'Waxed Exposed Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-exposed-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-exposed-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'exposed-cut-copper-stairs', amount: 1 }]
    }
  ]
},

'waxed-weathered-cut-copper-stairs': {
  id: 'waxed-weathered-cut-copper-stairs',
  name: 'Waxed Weathered Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-weathered-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-weathered-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'weathered-cut-copper-stairs', amount: 1 }]
    }
  ]
},

'waxed-oxidized-cut-copper-stairs': {
  id: 'waxed-oxidized-cut-copper-stairs',
  name: 'Waxed Oxidized Cut Copper Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'waxed-oxidized-cut-copper', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'waxed-oxidized-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'oxidized-cut-copper-stairs', amount: 1 }]
    }
  ]
},

// ==========================================
// WAXED COPPER SLABS
// ==========================================

'waxed-cut-copper-slab': {
  id: 'waxed-cut-copper-slab',
  name: 'Waxed Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'waxed-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'waxed-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'cut-copper-slab', amount: 1 }]
    }
  ]
},

'waxed-exposed-cut-copper-slab': {
  id: 'waxed-exposed-cut-copper-slab',
  name: 'Waxed Exposed Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'waxed-exposed-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'waxed-exposed-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'exposed-cut-copper-slab', amount: 1 }]
    }
  ]
},

'waxed-weathered-cut-copper-slab': {
  id: 'waxed-weathered-cut-copper-slab',
  name: 'Waxed Weathered Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'waxed-weathered-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'waxed-weathered-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'weathered-cut-copper-slab', amount: 1 }]
    }
  ]
},

'waxed-oxidized-cut-copper-slab': {
  id: 'waxed-oxidized-cut-copper-slab',
  name: 'Waxed Oxidized Cut Copper Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'waxed-oxidized-cut-copper', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'waxed-oxidized-cut-copper', amount: 1 }]
    },
    {
      method: 'interaction',
      tool: 'honeycomb',
      output: 1,
      ingredients: [{ id: 'oxidized-cut-copper-slab', amount: 1 }]
    }
  ]
},

// ==========================================
// CONCRETE POWDER (crafted)
// ==========================================

'white-concrete-powder': {
  id: 'white-concrete-powder',
  name: 'White Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'white-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'orange-concrete-powder': {
  id: 'orange-concrete-powder',
  name: 'Orange Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'orange-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'magenta-concrete-powder': {
  id: 'magenta-concrete-powder',
  name: 'Magenta Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'magenta-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'light-blue-concrete-powder': {
  id: 'light-blue-concrete-powder',
  name: 'Light Blue Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'light-blue-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'yellow-concrete-powder': {
  id: 'yellow-concrete-powder',
  name: 'Yellow Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'yellow-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'lime-concrete-powder': {
  id: 'lime-concrete-powder',
  name: 'Lime Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'lime-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'pink-concrete-powder': {
  id: 'pink-concrete-powder',
  name: 'Pink Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'pink-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'gray-concrete-powder': {
  id: 'gray-concrete-powder',
  name: 'Gray Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'gray-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'light-gray-concrete-powder': {
  id: 'light-gray-concrete-powder',
  name: 'Light Gray Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'light-gray-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'cyan-concrete-powder': {
  id: 'cyan-concrete-powder',
  name: 'Cyan Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'cyan-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'purple-concrete-powder': {
  id: 'purple-concrete-powder',
  name: 'Purple Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'purple-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'blue-concrete-powder': {
  id: 'blue-concrete-powder',
  name: 'Blue Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'blue-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'brown-concrete-powder': {
  id: 'brown-concrete-powder',
  name: 'Brown Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'brown-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'green-concrete-powder': {
  id: 'green-concrete-powder',
  name: 'Green Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'green-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'red-concrete-powder': {
  id: 'red-concrete-powder',
  name: 'Red Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'red-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

'black-concrete-powder': {
  id: 'black-concrete-powder',
  name: 'Black Concrete Powder',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'black-dye', amount: 1 },
      { id: 'sand', amount: 4 },
      { id: 'gravel', amount: 4 }
    ]
  }]
},

// ==========================================
// CONCRETE (interaction with water)
// ==========================================

'white-concrete': {
  id: 'white-concrete',
  name: 'White Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'white-concrete-powder', amount: 1 }]
  }]
},

'orange-concrete': {
  id: 'orange-concrete',
  name: 'Orange Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'orange-concrete-powder', amount: 1 }]
  }]
},

'magenta-concrete': {
  id: 'magenta-concrete',
  name: 'Magenta Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'magenta-concrete-powder', amount: 1 }]
  }]
},

'light-blue-concrete': {
  id: 'light-blue-concrete',
  name: 'Light Blue Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'light-blue-concrete-powder', amount: 1 }]
  }]
},

'yellow-concrete': {
  id: 'yellow-concrete',
  name: 'Yellow Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'yellow-concrete-powder', amount: 1 }]
  }]
},

'lime-concrete': {
  id: 'lime-concrete',
  name: 'Lime Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'lime-concrete-powder', amount: 1 }]
  }]
},

'pink-concrete': {
  id: 'pink-concrete',
  name: 'Pink Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'pink-concrete-powder', amount: 1 }]
  }]
},

'gray-concrete': {
  id: 'gray-concrete',
  name: 'Gray Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'gray-concrete-powder', amount: 1 }]
  }]
},

'light-gray-concrete': {
  id: 'light-gray-concrete',
  name: 'Light Gray Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'light-gray-concrete-powder', amount: 1 }]
  }]
},

'cyan-concrete': {
  id: 'cyan-concrete',
  name: 'Cyan Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'cyan-concrete-powder', amount: 1 }]
  }]
},

'purple-concrete': {
  id: 'purple-concrete',
  name: 'Purple Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'purple-concrete-powder', amount: 1 }]
  }]
},

'blue-concrete': {
  id: 'blue-concrete',
  name: 'Blue Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'blue-concrete-powder', amount: 1 }]
  }]
},

'brown-concrete': {
  id: 'brown-concrete',
  name: 'Brown Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'brown-concrete-powder', amount: 1 }]
  }]
},

'green-concrete': {
  id: 'green-concrete',
  name: 'Green Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'green-concrete-powder', amount: 1 }]
  }]
},

'red-concrete': {
  id: 'red-concrete',
  name: 'Red Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'red-concrete-powder', amount: 1 }]
  }]
},

'black-concrete': {
  id: 'black-concrete',
  name: 'Black Concrete',
  recipes: [{
    method: 'interaction',
    tool: 'water',
    output: 1,
    ingredients: [{ id: 'black-concrete-powder', amount: 1 }]
  }]
},

// ==========================================
// STAINED TERRACOTTA (crafted + smelted)
// ==========================================

'white-terracotta': {
  id: 'white-terracotta',
  name: 'White Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'white-dye', amount: 1 }
    ]
  }]
},

'orange-terracotta': {
  id: 'orange-terracotta',
  name: 'Orange Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'orange-dye', amount: 1 }
    ]
  }]
},

'magenta-terracotta': {
  id: 'magenta-terracotta',
  name: 'Magenta Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'magenta-dye', amount: 1 }
    ]
  }]
},

'light-blue-terracotta': {
  id: 'light-blue-terracotta',
  name: 'Light Blue Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'light-blue-dye', amount: 1 }
    ]
  }]
},

'yellow-terracotta': {
  id: 'yellow-terracotta',
  name: 'Yellow Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'yellow-dye', amount: 1 }
    ]
  }]
},

'lime-terracotta': {
  id: 'lime-terracotta',
  name: 'Lime Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'lime-dye', amount: 1 }
    ]
  }]
},

'pink-terracotta': {
  id: 'pink-terracotta',
  name: 'Pink Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'pink-dye', amount: 1 }
    ]
  }]
},

'gray-terracotta': {
  id: 'gray-terracotta',
  name: 'Gray Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'gray-dye', amount: 1 }
    ]
  }]
},

'light-gray-terracotta': {
  id: 'light-gray-terracotta',
  name: 'Light Gray Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'light-gray-dye', amount: 1 }
    ]
  }]
},

'cyan-terracotta': {
  id: 'cyan-terracotta',
  name: 'Cyan Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'cyan-dye', amount: 1 }
    ]
  }]
},

'purple-terracotta': {
  id: 'purple-terracotta',
  name: 'Purple Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'purple-dye', amount: 1 }
    ]
  }]
},

'blue-terracotta': {
  id: 'blue-terracotta',
  name: 'Blue Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'blue-dye', amount: 1 }
    ]
  }]
},

'brown-terracotta': {
  id: 'brown-terracotta',
  name: 'Brown Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'brown-dye', amount: 1 }
    ]
  }]
},

'green-terracotta': {
  id: 'green-terracotta',
  name: 'Green Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'green-dye', amount: 1 }
    ]
  }]
},

'red-terracotta': {
  id: 'red-terracotta',
  name: 'Red Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'red-dye', amount: 1 }
    ]
  }]
},

'black-terracotta': {
  id: 'black-terracotta',
  name: 'Black Terracotta',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'terracotta', amount: 8 },
      { id: 'black-dye', amount: 1 }
    ]
  }]
},

// ==========================================
// GLAZED TERRACOTTA (smelted)
// ==========================================

'white-glazed-terracotta': {
  id: 'white-glazed-terracotta',
  name: 'White Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'white-terracotta', amount: 1 }]
  }]
},

'orange-glazed-terracotta': {
  id: 'orange-glazed-terracotta',
  name: 'Orange Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'orange-terracotta', amount: 1 }]
  }]
},

'magenta-glazed-terracotta': {
  id: 'magenta-glazed-terracotta',
  name: 'Magenta Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'magenta-terracotta', amount: 1 }]
  }]
},

'light-blue-glazed-terracotta': {
  id: 'light-blue-glazed-terracotta',
  name: 'Light Blue Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'light-blue-terracotta', amount: 1 }]
  }]
},

'yellow-glazed-terracotta': {
  id: 'yellow-glazed-terracotta',
  name: 'Yellow Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'yellow-terracotta', amount: 1 }]
  }]
},

'lime-glazed-terracotta': {
  id: 'lime-glazed-terracotta',
  name: 'Lime Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'lime-terracotta', amount: 1 }]
  }]
},

'pink-glazed-terracotta': {
  id: 'pink-glazed-terracotta',
  name: 'Pink Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'pink-terracotta', amount: 1 }]
  }]
},

'gray-glazed-terracotta': {
  id: 'gray-glazed-terracotta',
  name: 'Gray Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'gray-terracotta', amount: 1 }]
  }]
},

'light-gray-glazed-terracotta': {
  id: 'light-gray-glazed-terracotta',
  name: 'Light Gray Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'light-gray-terracotta', amount: 1 }]
  }]
},

'cyan-glazed-terracotta': {
  id: 'cyan-glazed-terracotta',
  name: 'Cyan Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'cyan-terracotta', amount: 1 }]
  }]
},

'purple-glazed-terracotta': {
  id: 'purple-glazed-terracotta',
  name: 'Purple Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'purple-terracotta', amount: 1 }]
  }]
},

'blue-glazed-terracotta': {
  id: 'blue-glazed-terracotta',
  name: 'Blue Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'blue-terracotta', amount: 1 }]
  }]
},

'brown-glazed-terracotta': {
  id: 'brown-glazed-terracotta',
  name: 'Brown Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'brown-terracotta', amount: 1 }]
  }]
},

'green-glazed-terracotta': {
  id: 'green-glazed-terracotta',
  name: 'Green Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'green-terracotta', amount: 1 }]
  }]
},

'red-glazed-terracotta': {
  id: 'red-glazed-terracotta',
  name: 'Red Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'red-terracotta', amount: 1 }]
  }]
},

'black-glazed-terracotta': {
  id: 'black-glazed-terracotta',
  name: 'Black Glazed Terracotta',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'black-terracotta', amount: 1 }]
  }]
},

// ==========================================
// STAINED WOOL (crafted)
// ==========================================

'orange-wool': {
  id: 'orange-wool',
  name: 'Orange Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'orange-dye', amount: 1 }
    ]
  }]
},

'magenta-wool': {
  id: 'magenta-wool',
  name: 'Magenta Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'magenta-dye', amount: 1 }
    ]
  }]
},

'light-blue-wool': {
  id: 'light-blue-wool',
  name: 'Light Blue Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'light-blue-dye', amount: 1 }
    ]
  }]
},

'yellow-wool': {
  id: 'yellow-wool',
  name: 'Yellow Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'yellow-dye', amount: 1 }
    ]
  }]
},

'lime-wool': {
  id: 'lime-wool',
  name: 'Lime Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'lime-dye', amount: 1 }
    ]
  }]
},

'pink-wool': {
  id: 'pink-wool',
  name: 'Pink Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'pink-dye', amount: 1 }
    ]
  }]
},

'gray-wool': {
  id: 'gray-wool',
  name: 'Gray Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'gray-dye', amount: 1 }
    ]
  }]
},

'light-gray-wool': {
  id: 'light-gray-wool',
  name: 'Light Gray Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'light-gray-dye', amount: 1 }
    ]
  }]
},

'cyan-wool': {
  id: 'cyan-wool',
  name: 'Cyan Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'cyan-dye', amount: 1 }
    ]
  }]
},

'purple-wool': {
  id: 'purple-wool',
  name: 'Purple Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'purple-dye', amount: 1 }
    ]
  }]
},

'blue-wool': {
  id: 'blue-wool',
  name: 'Blue Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'blue-dye', amount: 1 }
    ]
  }]
},

'brown-wool': {
  id: 'brown-wool',
  name: 'Brown Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'brown-dye', amount: 1 }
    ]
  }]
},

'green-wool': {
  id: 'green-wool',
  name: 'Green Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'green-dye', amount: 1 }
    ]
  }]
},

'red-wool': {
  id: 'red-wool',
  name: 'Red Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'red-dye', amount: 1 }
    ]
  }]
},

'black-wool': {
  id: 'black-wool',
  name: 'Black Wool',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 1 },
      { id: 'black-dye', amount: 1 }
    ]
  }]
},

// ==========================================
// CARPET (crafted from wool)
// ==========================================

'white-carpet': {
  id: 'white-carpet',
  name: 'White Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'white-wool', amount: 2 }
    ]
  }]
},

'orange-carpet': {
  id: 'orange-carpet',
  name: 'Orange Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'orange-wool', amount: 2 }
    ]
  }]
},

'magenta-carpet': {
  id: 'magenta-carpet',
  name: 'Magenta Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'magenta-wool', amount: 2 }
    ]
  }]
},

'light-blue-carpet': {
  id: 'light-blue-carpet',
  name: 'Light Blue Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'light-blue-wool', amount: 2 }
    ]
  }]
},

'yellow-carpet': {
  id: 'yellow-carpet',
  name: 'Yellow Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'yellow-wool', amount: 2 }
    ]
  }]
},

'lime-carpet': {
  id: 'lime-carpet',
  name: 'Lime Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'lime-wool', amount: 2 }
    ]
  }]
},

'pink-carpet': {
  id: 'pink-carpet',
  name: 'Pink Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'pink-wool', amount: 2 }
    ]
  }]
},

'gray-carpet': {
  id: 'gray-carpet',
  name: 'Gray Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'gray-wool', amount: 2 }
    ]
  }]
},

'light-gray-carpet': {
  id: 'light-gray-carpet',
  name: 'Light Gray Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'light-gray-wool', amount: 2 }
    ]
  }]
},

'cyan-carpet': {
  id: 'cyan-carpet',
  name: 'Cyan Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'cyan-wool', amount: 2 }
    ]
  }]
},

'purple-carpet': {
  id: 'purple-carpet',
  name: 'Purple Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'purple-wool', amount: 2 }
    ]
  }]
},

'blue-carpet': {
  id: 'blue-carpet',
  name: 'Blue Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'blue-wool', amount: 2 }
    ]
  }]
},

'brown-carpet': {
  id: 'brown-carpet',
  name: 'Brown Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'brown-wool', amount: 2 }
    ]
  }]
},

'green-carpet': {
  id: 'green-carpet',
  name: 'Green Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'green-wool', amount: 2 }
    ]
  }]
},

'red-carpet': {
  id: 'red-carpet',
  name: 'Red Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'red-wool', amount: 2 }
    ]
  }]
},

'black-carpet': {
  id: 'black-carpet',
  name: 'Black Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'black-wool', amount: 2 }
    ]
  }]
},

// ==========================================
// STAINED GLASS (crafted)
// ==========================================

'white-stained-glass': {
  id: 'white-stained-glass',
  name: 'White Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'white-dye', amount: 1 }
    ]
  }]
},

'orange-stained-glass': {
  id: 'orange-stained-glass',
  name: 'Orange Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'orange-dye', amount: 1 }
    ]
  }]
},

'magenta-stained-glass': {
  id: 'magenta-stained-glass',
  name: 'Magenta Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'magenta-dye', amount: 1 }
    ]
  }]
},

'light-blue-stained-glass': {
  id: 'light-blue-stained-glass',
  name: 'Light Blue Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'light-blue-dye', amount: 1 }
    ]
  }]
},

'yellow-stained-glass': {
  id: 'yellow-stained-glass',
  name: 'Yellow Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'yellow-dye', amount: 1 }
    ]
  }]
},

'lime-stained-glass': {
  id: 'lime-stained-glass',
  name: 'Lime Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'lime-dye', amount: 1 }
    ]
  }]
},

'pink-stained-glass': {
  id: 'pink-stained-glass',
  name: 'Pink Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'pink-dye', amount: 1 }
    ]
  }]
},

'gray-stained-glass': {
  id: 'gray-stained-glass',
  name: 'Gray Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'gray-dye', amount: 1 }
    ]
  }]
},

'light-gray-stained-glass': {
  id: 'light-gray-stained-glass',
  name: 'Light Gray Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'light-gray-dye', amount: 1 }
    ]
  }]
},

'cyan-stained-glass': {
  id: 'cyan-stained-glass',
  name: 'Cyan Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'cyan-dye', amount: 1 }
    ]
  }]
},

'purple-stained-glass': {
  id: 'purple-stained-glass',
  name: 'Purple Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'purple-dye', amount: 1 }
    ]
  }]
},

'blue-stained-glass': {
  id: 'blue-stained-glass',
  name: 'Blue Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'blue-dye', amount: 1 }
    ]
  }]
},

'brown-stained-glass': {
  id: 'brown-stained-glass',
  name: 'Brown Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'brown-dye', amount: 1 }
    ]
  }]
},

'green-stained-glass': {
  id: 'green-stained-glass',
  name: 'Green Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'green-dye', amount: 1 }
    ]
  }]
},

'red-stained-glass': {
  id: 'red-stained-glass',
  name: 'Red Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'red-dye', amount: 1 }
    ]
  }]
},

'black-stained-glass': {
  id: 'black-stained-glass',
  name: 'Black Stained Glass',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'glass', amount: 8 },
      { id: 'black-dye', amount: 1 }
    ]
  }]
},

// ==========================================
// GLASS PANES (crafted)
// ==========================================

'glass-pane': {
  id: 'glass-pane',
  name: 'Glass Pane',
  recipes: [{
    method: 'crafting_table',
    output: 16,
    ingredients: [
      { id: 'glass', amount: 6 }
    ]
  }]
},

'white-stained-glass-pane': {
  id: 'white-stained-glass-pane',
  name: 'White Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'white-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'white-dye', amount: 1 }
      ]
    }
  ]
},

'orange-stained-glass-pane': {
  id: 'orange-stained-glass-pane',
  name: 'Orange Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'orange-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'orange-dye', amount: 1 }
      ]
    }
  ]
},

'magenta-stained-glass-pane': {
  id: 'magenta-stained-glass-pane',
  name: 'Magenta Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'magenta-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'magenta-dye', amount: 1 }
      ]
    }
  ]
},

'light-blue-stained-glass-pane': {
  id: 'light-blue-stained-glass-pane',
  name: 'Light Blue Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'light-blue-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'light-blue-dye', amount: 1 }
      ]
    }
  ]
},

'yellow-stained-glass-pane': {
  id: 'yellow-stained-glass-pane',
  name: 'Yellow Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'yellow-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'yellow-dye', amount: 1 }
      ]
    }
  ]
},

'lime-stained-glass-pane': {
  id: 'lime-stained-glass-pane',
  name: 'Lime Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'lime-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'lime-dye', amount: 1 }
      ]
    }
  ]
},

'pink-stained-glass-pane': {
  id: 'pink-stained-glass-pane',
  name: 'Pink Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'pink-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'pink-dye', amount: 1 }
      ]
    }
  ]
},

'gray-stained-glass-pane': {
  id: 'gray-stained-glass-pane',
  name: 'Gray Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'gray-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'gray-dye', amount: 1 }
      ]
    }
  ]
},

'light-gray-stained-glass-pane': {
  id: 'light-gray-stained-glass-pane',
  name: 'Light Gray Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'light-gray-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'light-gray-dye', amount: 1 }
      ]
    }
  ]
},

'cyan-stained-glass-pane': {
  id: 'cyan-stained-glass-pane',
  name: 'Cyan Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'cyan-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'cyan-dye', amount: 1 }
      ]
    }
  ]
},

'purple-stained-glass-pane': {
  id: 'purple-stained-glass-pane',
  name: 'Purple Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'purple-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'purple-dye', amount: 1 }
      ]
    }
  ]
},

'blue-stained-glass-pane': {
  id: 'blue-stained-glass-pane',
  name: 'Blue Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'blue-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'blue-dye', amount: 1 }
      ]
    }
  ]
},

'brown-stained-glass-pane': {
  id: 'brown-stained-glass-pane',
  name: 'Brown Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'brown-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'brown-dye', amount: 1 }
      ]
    }
  ]
},

'green-stained-glass-pane': {
  id: 'green-stained-glass-pane',
  name: 'Green Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'green-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'green-dye', amount: 1 }
      ]
    }
  ]
},

'red-stained-glass-pane': {
  id: 'red-stained-glass-pane',
  name: 'Red Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'red-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'red-dye', amount: 1 }
      ]
    }
  ]
},

'black-stained-glass-pane': {
  id: 'black-stained-glass-pane',
  name: 'Black Stained Glass Pane',
  recipes: [
    {
      method: 'crafting_table',
      output: 16,
      ingredients: [
        { id: 'black-stained-glass', amount: 6 }
      ]
    },
    {
      method: 'crafting_table',
      output: 8,
      ingredients: [
        { id: 'glass-pane', amount: 8 },
        { id: 'black-dye', amount: 1 }
      ]
    }
  ]
},

// ==========================================
// TINTED GLASS
// ==========================================

'tinted-glass': {
  id: 'tinted-glass',
  name: 'Tinted Glass',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'glass', amount: 1 },
      { id: 'amethyst-shard', amount: 4 }
    ]
  }]
},

// ==========================================
// BASALT VARIANTS (crafted/smelted)
// ==========================================

'polished-basalt': {
  id: 'polished-basalt',
  name: 'Polished Basalt',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'basalt', amount: 4 }
    ]
  }]
},

'smooth-basalt': {
  id: 'smooth-basalt',
  name: 'Smooth Basalt',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'basalt', amount: 1 }]
  }]
},

// ==========================================
// MAGMA & NETHER BLOCKS
// ==========================================

'magma-block': {
  id: 'magma-block',
  name: 'Magma Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'magma-cream', amount: 4 }
    ]
  }]
},

'nether-wart-block': {
  id: 'nether-wart-block',
  name: 'Nether Wart Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'nether-wart', amount: 9 }
    ]
  }]
},

// ==========================================
// BONE BLOCK
// ==========================================

'bone-block': {
  id: 'bone-block',
  name: 'Bone Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bone-meal', amount: 9 }
    ]
  }]
},

// ==========================================
// DRIED KELP BLOCK
// ==========================================

'dried-kelp-block': {
  id: 'dried-kelp-block',
  name: 'Dried Kelp Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'dried-kelp', amount: 9 }
    ]
  }]
},

// ==========================================
// HAY BALE
// ==========================================

'hay-bale': {
  id: 'hay-bale',
  name: 'Hay Bale',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'wheat', amount: 9 }
    ]
  }]
},

// ==========================================
// MOSS BLOCK & VARIANTS
// ==========================================

'moss-carpet': {
  id: 'moss-carpet',
  name: 'Moss Carpet',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'moss-block', amount: 2 }
    ]
  }]
},

// ==========================================
// DIRT VARIANTS
// ==========================================

'coarse-dirt': {
  id: 'coarse-dirt',
  name: 'Coarse Dirt',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'dirt', amount: 2 },
      { id: 'gravel', amount: 2 }
    ]
  }]
},



// ==========================================
// ICE & SNOW
// ==========================================

'packed-ice': {
  id: 'packed-ice',
  name: 'Packed Ice',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'ice', amount: 9 }
    ]
  }]
},

'blue-ice': {
  id: 'blue-ice',
  name: 'Blue Ice',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'packed-ice', amount: 9 }
    ]
  }]
},

'snow-block': {
  id: 'snow-block',
  name: 'Snow Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'snowball', amount: 4 }
    ]
  }]
},

// ==========================================
// GLOWSTONE & SHROOMLIGHT
// ==========================================

'glowstone': {
  id: 'glowstone',
  name: 'Glowstone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'glowstone-dust', amount: 4 }
    ]
  }]
},

// ==========================================
// BASIC WORKSTATIONS
// ==========================================

'crafting-table': {
  id: 'crafting-table',
  name: 'Crafting Table',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 4 }
    ]
  }]
},

'crafter': {
  id: 'crafter',
  name: 'Crafter',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 5 },
      { id: 'redstone', amount: 2 },
      { id: 'crafting-table', amount: 1 },
      { id: 'dropper', amount: 1 }
    ]
  }]
},

'furnace': {
  id: 'furnace',
  name: 'Furnace',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cobblestone', amount: 8 }
    ]
  }]
},

'blast-furnace': {
  id: 'blast-furnace',
  name: 'Blast Furnace',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 5 },
      { id: 'furnace', amount: 1 },
      { id: 'smooth-stone', amount: 3 }
    ]
  }]
},

'smoker': {
  id: 'smoker',
  name: 'Smoker',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'logs', amount: 4 },
      { id: 'furnace', amount: 1 }
    ]
  }]
},

'stonecutter': {
  id: 'stonecutter',
  name: 'Stonecutter',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 1 },
      { id: 'stone', amount: 3 }
    ]
  }]
},

'smithing-table': {
  id: 'smithing-table',
  name: 'Smithing Table',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 2 },
      { tag: 'planks', amount: 4 }
    ]
  }]
},

'anvil': {
  id: 'anvil',
  name: 'Anvil',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-block', amount: 3 },
      { id: 'iron-ingot', amount: 4 }
    ]
  }]
},

'grindstone': {
  id: 'grindstone',
  name: 'Grindstone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 2 },
      { id: 'stone-slab', amount: 1 },
      { tag: 'planks', amount: 2 }
    ]
  }]
},

'loom': {
  id: 'loom',
  name: 'Loom',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'string', amount: 2 },
      { tag: 'planks', amount: 2 }
    ]
  }]
},

'cartography-table': {
  id: 'cartography-table',
  name: 'Cartography Table',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'paper', amount: 2 },
      { tag: 'planks', amount: 4 }
    ]
  }]
},

'fletching-table': {
  id: 'fletching-table',
  name: 'Fletching Table',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'flint', amount: 2 },
      { tag: 'planks', amount: 4 }
    ]
  }]
},

// ==========================================
// STORAGE BLOCKS
// ==========================================

'chest': {
  id: 'chest',
  name: 'Chest',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 8 }
    ]
  }]
},

'barrel': {
  id: 'barrel',
  name: 'Barrel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 6 },
      { tag: 'slabs', amount: 2 }
    ]
  }]
},

'shulker-box': {
  id: 'shulker-box',
  name: 'Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-shell', amount: 2 },
      { id: 'chest', amount: 1 }
    ]
  }]
},

// ==========================================
// REDSTONE COMPONENTS
// ==========================================

'redstone-block': {
  id: 'redstone-block',
  name: 'Block of Redstone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'redstone', amount: 9 }
    ]
  }]
},

'redstone-torch': {
  id: 'redstone-torch',
  name: 'Redstone Torch',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'redstone', amount: 1 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'redstone-repeater': {
  id: 'redstone-repeater',
  name: 'Redstone Repeater',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'redstone-torch', amount: 2 },
      { id: 'redstone', amount: 1 },
      { id: 'stone', amount: 3 }
    ]
  }]
},

'redstone-comparator': {
  id: 'redstone-comparator',
  name: 'Redstone Comparator',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'redstone-torch', amount: 3 },
      { id: 'nether-quartz', amount: 1 },
      { id: 'stone', amount: 3 }
    ]
  }]
},

'piston': {
  id: 'piston',
  name: 'Piston',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 3 },
      { id: 'cobblestone', amount: 4 },
      { id: 'iron-ingot', amount: 1 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'sticky-piston': {
  id: 'sticky-piston',
  name: 'Sticky Piston',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'slime-ball', amount: 1 },
      { id: 'piston', amount: 1 }
    ]
  }]
},

'observer': {
  id: 'observer',
  name: 'Observer',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cobblestone', amount: 6 },
      { id: 'redstone', amount: 2 },
      { id: 'nether-quartz', amount: 1 }
    ]
  }]
},

'hopper': {
  id: 'hopper',
  name: 'Hopper',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 5 },
      { id: 'chest', amount: 1 }
    ]
  }]
},

'dropper': {
  id: 'dropper',
  name: 'Dropper',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cobblestone', amount: 7 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'dispenser': {
  id: 'dispenser',
  name: 'Dispenser',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cobblestone', amount: 7 },
      { id: 'redstone', amount: 1 },
      { id: 'bow', amount: 1 }
    ]
  }]
},

'note-block': {
  id: 'note-block',
  name: 'Note Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 8 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'redstone-lamp': {
  id: 'redstone-lamp',
  name: 'Redstone Lamp',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'redstone', amount: 4 },
      { id: 'glowstone', amount: 1 }
    ]
  }]
},

'lever': {
  id: 'lever',
  name: 'Lever',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 1 },
      { id: 'cobblestone', amount: 1 }
    ]
  }]
},

'tripwire-hook': {
  id: 'tripwire-hook',
  name: 'Tripwire Hook',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'iron-ingot', amount: 1 },
      { id: 'stick', amount: 1 },
      { tag: 'planks', amount: 1 }
    ]
  }]
},

// ==========================================
// TORCHES
// ==========================================

'torch': {
  id: 'torch',
  name: 'Torch',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'stick', amount: 1 },
      { tag: 'coal', amount: 1 }
    ]
  }]
},

'soul-torch': {
  id: 'soul-torch',
  name: 'Soul Torch',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'stick', amount: 1 },
      { tag: 'soul-soil-or-sand', amount: 1 },
      { tag: 'coal', amount: 1 }
    ]
  }]
},

// ==========================================
// LANTERNS
// ==========================================

'lantern': {
  id: 'lantern',
  name: 'Lantern',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-nugget', amount: 8 },
      { id: 'torch', amount: 1 }
    ]
  }]
},

'soul-lantern': {
  id: 'soul-lantern',
  name: 'Soul Lantern',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-nugget', amount: 8 },
      { id: 'soul-torch', amount: 1 }
    ]
  }]
},

// ==========================================
// CAMPFIRES
// ==========================================

'campfire': {
  id: 'campfire',
  name: 'Campfire',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 3 },
      { tag: 'coal', amount: 1 },
      { tag: 'logs', amount: 3 }
    ]
  }]
},

'soul-campfire': {
  id: 'soul-campfire',
  name: 'Soul Campfire',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 3 },
      { tag: 'soul-soil-or-sand', amount: 1 },
      { tag: 'logs', amount: 3 }
    ]
  }]
},

// ==========================================
// CANDLES
// ==========================================

'candle': {
  id: 'candle',
  name: 'Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'string', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'white-candle': {
  id: 'white-candle',
  name: 'White Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'white-dye', amount: 1 }
    ]
  }]
},

'orange-candle': {
  id: 'orange-candle',
  name: 'Orange Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'orange-dye', amount: 1 }
    ]
  }]
},

'magenta-candle': {
  id: 'magenta-candle',
  name: 'Magenta Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'magenta-dye', amount: 1 }
    ]
  }]
},

'light-blue-candle': {
  id: 'light-blue-candle',
  name: 'Light Blue Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'light-blue-dye', amount: 1 }
    ]
  }]
},

'yellow-candle': {
  id: 'yellow-candle',
  name: 'Yellow Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'yellow-dye', amount: 1 }
    ]
  }]
},

'lime-candle': {
  id: 'lime-candle',
  name: 'Lime Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'lime-dye', amount: 1 }
    ]
  }]
},

'pink-candle': {
  id: 'pink-candle',
  name: 'Pink Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'pink-dye', amount: 1 }
    ]
  }]
},

'gray-candle': {
  id: 'gray-candle',
  name: 'Gray Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'gray-dye', amount: 1 }
    ]
  }]
},

'light-gray-candle': {
  id: 'light-gray-candle',
  name: 'Light Gray Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'light-gray-dye', amount: 1 }
    ]
  }]
},

'cyan-candle': {
  id: 'cyan-candle',
  name: 'Cyan Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'cyan-dye', amount: 1 }
    ]
  }]
},

'purple-candle': {
  id: 'purple-candle',
  name: 'Purple Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'purple-dye', amount: 1 }
    ]
  }]
},

'blue-candle': {
  id: 'blue-candle',
  name: 'Blue Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'blue-dye', amount: 1 }
    ]
  }]
},

'brown-candle': {
  id: 'brown-candle',
  name: 'Brown Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'brown-dye', amount: 1 }
    ]
  }]
},

'green-candle': {
  id: 'green-candle',
  name: 'Green Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'green-dye', amount: 1 }
    ]
  }]
},

'red-candle': {
  id: 'red-candle',
  name: 'Red Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'red-dye', amount: 1 }
    ]
  }]
},

'black-candle': {
  id: 'black-candle',
  name: 'Black Candle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'candle', amount: 1 },
      { id: 'black-dye', amount: 1 }
    ]
  }]
},

// ==========================================
// END ROD & CHORUS PLANT
// ==========================================

'end-rod': {
  id: 'end-rod',
  name: 'End Rod',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'blaze-rod', amount: 1 },
      { id: 'popped-chorus-fruit', amount: 1 }
    ]
  }]
},

// ==========================================
// JACK O'LANTERN
// ==========================================

'jack-o-lantern': {
  id: 'jack-o-lantern',
  name: 'Jack o\'Lantern',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'carved-pumpkin', amount: 1 },
      { id: 'torch', amount: 1 }
    ]
  }]
},

// ==========================================
// RESPAWN ANCHOR
// ==========================================

'respawn-anchor': {
  id: 'respawn-anchor',
  name: 'Respawn Anchor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'crying-obsidian', amount: 6 },
      { id: 'glowstone', amount: 3 }
    ]
  }]
},

// ==========================================
// COPPER BULBS (The 1.21 lighting logic)
// ==========================================

'copper-bulb': {
  id: 'copper-bulb',
  name: 'Copper Bulb',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'copper-block', amount: 3 },
      { id: 'blaze-rod', amount: 1 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER BULBS (Base Oxidation States)
// ==========================================

'exposed-copper-bulb': {
  id: 'exposed-copper-bulb',
  name: 'Exposed Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'time',
    output: 1,
    ingredients: [{ id: 'copper-bulb', amount: 1 }]
  }]
},

'weathered-copper-bulb': {
  id: 'weathered-copper-bulb',
  name: 'Weathered Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'time',
    output: 1,
    ingredients: [{ id: 'exposed-copper-bulb', amount: 1 }]
  }]
},

'oxidized-copper-bulb': {
  id: 'oxidized-copper-bulb',
  name: 'Oxidized Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'time',
    output: 1,
    ingredients: [{ id: 'weathered-copper-bulb', amount: 1 }]
  }]
},

// ==========================================
// WAXED COPPER BULBS (The "Honeyed" Set)
// ==========================================

'waxed-copper-bulb': {
  id: 'waxed-copper-bulb',
  name: 'Waxed Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'copper-bulb', amount: 1 }, { id: 'honeycomb', amount: 1 }]
  }]
},

'waxed-exposed-copper-bulb': {
  id: 'waxed-exposed-copper-bulb',
  name: 'Waxed Exposed Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'exposed-copper-bulb', amount: 1 }, { id: 'honeycomb', amount: 1 }]
  }]
},

'waxed-weathered-copper-bulb': {
  id: 'waxed-weathered-copper-bulb',
  name: 'Waxed Weathered Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'weathered-copper-bulb', amount: 1 }, { id: 'honeycomb', amount: 1 }]
  }]
},

'waxed-oxidized-copper-bulb': {
  id: 'waxed-oxidized-copper-bulb',
  name: 'Waxed Oxidized Copper Bulb',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [{ id: 'oxidized-copper-bulb', amount: 1 }, { id: 'honeycomb', amount: 1 }]
  }]
},

// ==========================================
// SMELTED INGOTS
// ==========================================

'iron-ingot': {
  id: 'iron-ingot',
  name: 'Iron Ingot',
  recipes: [
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'raw-iron', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'iron-ore', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'deepslate-iron-ore', amount: 1 }]
    },
    {
      method: 'crafting_table',
      output: 9,
      ingredients: [{ id: 'iron-block', amount: 1 }]
    }
  ]
},

'gold-ingot': {
  id: 'gold-ingot',
  name: 'Gold Ingot',
  recipes: [
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'raw-gold', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'gold-ore', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'deepslate-gold-ore', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'nether-gold-ore', amount: 1 }]
    },
    {
      method: 'crafting_table',
      output: 9,
      ingredients: [{ id: 'gold-block', amount: 1 }]
    }
  ]
},

'netherite-scrap': {
  id: 'netherite-scrap',
  name: 'Netherite Scrap',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'ancient-debris', amount: 1 }]
  }]
},

'netherite-ingot': {
  id: 'netherite-ingot',
  name: 'Netherite Ingot',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'netherite-scrap', amount: 4 },
      { id: 'gold-ingot', amount: 4 }
    ]
  }]
},

// ==========================================
// METAL BLOCKS (crafted from ingots)
// ==========================================

'iron-block': {
  id: 'iron-block',
  name: 'Block of Iron',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'iron-ingot', amount: 9 }]
  }]
},

'gold-block': {
  id: 'gold-block',
  name: 'Block of Gold',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'gold-ingot', amount: 9 }]
  }]
},

'diamond-block': {
  id: 'diamond-block',
  name: 'Block of Diamond',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'diamond', amount: 9 }]
  }]
},

'emerald-block': {
  id: 'emerald-block',
  name: 'Block of Emerald',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'emerald', amount: 9 }]
  }]
},

'lapis-block': {
  id: 'lapis-block',
  name: 'Block of Lapis Lazuli',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'lapis-lazuli', amount: 9 }]
  }]
},

'coal-block': {
  id: 'coal-block',
  name: 'Block of Coal',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'coal', amount: 9 }]
  }]
},

'netherite-block': {
  id: 'netherite-block',
  name: 'Block of Netherite',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'netherite-ingot', amount: 9 }]
  }]
},

'raw-iron-block': {
  id: 'raw-iron-block',
  name: 'Block of Raw Iron',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'raw-iron', amount: 9 }]
  }]
},

'raw-gold-block': {
  id: 'raw-gold-block',
  name: 'Block of Raw Gold',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'raw-gold', amount: 9 }]
  }]
},

'raw-copper-block': {
  id: 'raw-copper-block',
  name: 'Block of Raw Copper',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'raw-copper', amount: 9 }]
  }]
},

// ==========================================
// AMETHYST BLOCK
// ==========================================

'amethyst-block': {
  id: 'amethyst-block',
  name: 'Block of Amethyst',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'amethyst-shard', amount: 4 }]
  }]
},

// ==========================================
// IRON BARS, CHAINS, NUGGETS
// ==========================================

'iron-bars': {
  id: 'iron-bars',
  name: 'Iron Bars',
  recipes: [{
    method: 'crafting_table',
    output: 16,
    ingredients: [{ id: 'iron-ingot', amount: 6 }]
  }]
},

'iron-chain': {
  id: 'iron-chain',
  name: 'iron-chain',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 1 },
      { id: 'iron-nugget', amount: 2 }
    ]
  }]
},

'iron-nugget': {
  id: 'iron-nugget',
  name: 'Iron Nugget',
  recipes: [{
    method: 'crafting_table',
    output: 9,
    ingredients: [{ id: 'iron-ingot', amount: 1 }]
  }]
},

'gold-nugget': {
  id: 'gold-nugget',
  name: 'Gold Nugget',
  recipes: [{
    method: 'crafting_table',
    output: 9,
    ingredients: [{ id: 'gold-ingot', amount: 1 }]
  }]
},

// ==========================================
// LODESTONE & RESPAWN ANCHOR (already added)
// ==========================================

'lodestone': {
  id: 'lodestone',
  name: 'Lodestone',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'chiseled-stone-bricks', amount: 8 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

// ==========================================
// BEACON
// ==========================================

'beacon': {
  id: 'beacon',
  name: 'Beacon',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'glass', amount: 5 },
      { id: 'nether-star', amount: 1 },
      { id: 'obsidian', amount: 3 }
    ]
  }]
},



// ==========================================
// CONDUIT
// ==========================================

'conduit': {
  id: 'conduit',
  name: 'Conduit',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'nautilus-shell', amount: 8 },
      { id: 'heart-of-the-sea', amount: 1 }
    ]
  }]
},

'ladder': {
  id: 'ladder',
  name: 'Ladder',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [{ id: 'stick', amount: 7 }]
  }]
},

'scaffolding': {
  id: 'scaffolding',
  name: 'Scaffolding',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'bamboo', amount: 6 },
      { id: 'string', amount: 1 }
    ]
  }]
},



// ==========================================
// SIGNS (crafted)
// ==========================================

'oak-sign': {
  id: 'oak-sign',
  name: 'Oak Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'oak-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'spruce-sign': {
  id: 'spruce-sign',
  name: 'Spruce Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'spruce-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'birch-sign': {
  id: 'birch-sign',
  name: 'Birch Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'birch-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'jungle-sign': {
  id: 'jungle-sign',
  name: 'Jungle Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'jungle-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'acacia-sign': {
  id: 'acacia-sign',
  name: 'Acacia Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'acacia-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'dark-oak-sign': {
  id: 'dark-oak-sign',
  name: 'Dark Oak Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'dark-oak-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'mangrove-sign': {
  id: 'mangrove-sign',
  name: 'Mangrove Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'mangrove-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'cherry-sign': {
  id: 'cherry-sign',
  name: 'Cherry Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'cherry-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'bamboo-sign': {
  id: 'bamboo-sign',
  name: 'Bamboo Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'bamboo-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'crimson-sign': {
  id: 'crimson-sign',
  name: 'Crimson Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'crimson-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'warped-sign': {
  id: 'warped-sign',
  name: 'Warped Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'warped-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// HANGING SIGNS (crafted)
// ==========================================

'oak-hanging-sign': {
  id: 'oak-hanging-sign',
  name: 'Oak Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'oak-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'spruce-hanging-sign': {
  id: 'spruce-hanging-sign',
  name: 'Spruce Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'spruce-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'birch-hanging-sign': {
  id: 'birch-hanging-sign',
  name: 'Birch Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'birch-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'jungle-hanging-sign': {
  id: 'jungle-hanging-sign',
  name: 'Jungle Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'jungle-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'acacia-hanging-sign': {
  id: 'acacia-hanging-sign',
  name: 'Acacia Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'acacia-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'dark-oak-hanging-sign': {
  id: 'dark-oak-hanging-sign',
  name: 'Dark Oak Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'dark-oak-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'mangrove-hanging-sign': {
  id: 'mangrove-hanging-sign',
  name: 'Mangrove Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'mangrove-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'cherry-hanging-sign': {
  id: 'cherry-hanging-sign',
  name: 'Cherry Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'cherry-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'bamboo-hanging-sign': {
  id: 'bamboo-hanging-sign',
  name: 'Bamboo Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'bamboo', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'crimson-hanging-sign': {
  id: 'crimson-hanging-sign',
  name: 'Crimson Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'crimson-stem', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

'warped-hanging-sign': {
  id: 'warped-hanging-sign',
  name: 'Warped Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'warped-stem', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},

// ==========================================
// BASIC INGREDIENTS (crafted)
// ==========================================

'sugar': {
  id: 'sugar',
  name: 'Sugar',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'sugar-cane', amount: 1 }
    ]
  }]
},

'paper': {
  id: 'paper',
  name: 'Paper',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'sugar-cane', amount: 3 }
    ]
  }]
},

// ==========================================
// BREAD & BAKED GOODS
// ==========================================

'bread': {
  id: 'bread',
  name: 'Bread',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'wheat', amount: 3 }
    ]
  }]
},

'cookie': {
  id: 'cookie',
  name: 'Cookie',
  recipes: [{
    method: 'crafting_table',
    output: 8,
    ingredients: [
      { id: 'wheat', amount: 2 },
      { id: 'cocoa-beans', amount: 1 }
    ]
  }]
},

'cake': {
  id: 'cake',
  name: 'Cake',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'milk-bucket', amount: 3 },
      { id: 'sugar', amount: 2 },
      { id: 'egg', amount: 1 },
      { id: 'wheat', amount: 3 }
    ],
    returns: { id: 'bucket', amount: 3 }
  }]
},

'pumpkin-pie': {
  id: 'pumpkin-pie',
  name: 'Pumpkin Pie',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'pumpkin', amount: 1 },
      { id: 'sugar', amount: 1 },
      { id: 'egg', amount: 1 }
    ]
  }]
},

// ==========================================
// MELON & PUMPKIN BLOCKS
// ==========================================

'melon': {
  id: 'melon',
  name: 'Melon',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'melon-slice', amount: 9 }
    ]
  }]
},

// ==========================================
// STEWS & SOUPS
// ==========================================

'mushroom-stew': {
  id: 'mushroom-stew',
  name: 'Mushroom Stew',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'brown-mushroom', amount: 1 },
      { id: 'red-mushroom', amount: 1 },
      { id: 'bowl', amount: 1 }
    ]
  }]
},

'rabbit-stew': {
  id: 'rabbit-stew',
  name: 'Rabbit Stew',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cooked-rabbit', amount: 1 },
      { id: 'carrot', amount: 1 },
      { id: 'baked-potato', amount: 1 },
      { id: 'brown-mushroom', amount: 1 },
      { id: 'bowl', amount: 1 }
    ]
  }]
},

'beetroot-soup': {
  id: 'beetroot-soup',
  name: 'Beetroot Soup',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'beetroot', amount: 6 },
      { id: 'bowl', amount: 1 }
    ]
  }]
},



'bowl': {
  id: 'bowl',
  name: 'Bowl',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { tag: 'planks', amount: 3 }
    ]
  }]
},

// ==========================================
// COOKED FOODS (smelting)
// ==========================================

'cooked-beef': {
  id: 'cooked-beef',
  name: 'Steak',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'beef', amount: 1 }]
  }]
},

'cooked-porkchop': {
  id: 'cooked-porkchop',
  name: 'Cooked Porkchop',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'porkchop', amount: 1 }]
  }]
},

'cooked-chicken': {
  id: 'cooked-chicken',
  name: 'Cooked Chicken',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'chicken', amount: 1 }]
  }]
},

'cooked-mutton': {
  id: 'cooked-mutton',
  name: 'Cooked Mutton',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'mutton', amount: 1 }]
  }]
},

'cooked-rabbit': {
  id: 'cooked-rabbit',
  name: 'Cooked Rabbit',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'rabbit', amount: 1 }]
  }]
},

'cooked-cod': {
  id: 'cooked-cod',
  name: 'Cooked Cod',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'cod', amount: 1 }]
  }]
},

'cooked-salmon': {
  id: 'cooked-salmon',
  name: 'Cooked Salmon',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'salmon', amount: 1 }]
  }]
},

'baked-potato': {
  id: 'baked-potato',
  name: 'Baked Potato',
  recipes: [{
    method: 'smelting',
    output: 1,
    ingredients: [{ id: 'potato', amount: 1 }]
  }]
},

// ==========================================
// GOLDEN FOODS
// ==========================================

'golden-apple': {
  id: 'golden-apple',
  name: 'Golden Apple',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 8 },
      { id: 'apple', amount: 1 }
    ]
  }]
},

'golden-carrot': {
  id: 'golden-carrot',
  name: 'Golden Carrot',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-nugget', amount: 8 },
      { id: 'carrot', amount: 1 }
    ]
  }]
},

'glistering-melon-slice': {
  id: 'glistering-melon-slice',
  name: 'Glistering Melon Slice',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-nugget', amount: 8 },
      { id: 'melon-slice', amount: 1 }
    ]
  }]
},

// ==========================================
// HONEY ITEMS
// ==========================================


'honey-block': {
  id: 'honey-block',
  name: 'Honey Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'honey-bottle', amount: 4 }
    ],
    returns: { id: 'glass-bottle', amount: 4 }
  }]
},

'honeycomb-block': {
  id: 'honeycomb-block',
  name: 'Honeycomb Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'honeycomb', amount: 4 }
    ]
  }]
},



// ==========================================
// FARMING BLOCKS
// ==========================================

'composter': {
  id: 'composter',
  name: 'Composter',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'slabs', amount: 7 }
    ]
  }]
},

'beehive': {
  id: 'beehive',
  name: 'Beehive',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 6 },
      { id: 'honeycomb', amount: 3 }
    ]
  }]
},

// ==========================================
// BOOKS
// ==========================================

'book': {
  id: 'book',
  name: 'Book',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'paper', amount: 3 },
      { id: 'leather', amount: 1 }
    ]
  }]
},

'writable-book': {
  id: 'writable-book',
  name: 'Book and Quill',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'book', amount: 1 },
      { id: 'ink-sac', amount: 1 },
      { id: 'feather', amount: 1 }
    ]
  }]
},



// ==========================================
// BOOKSHELVES
// ==========================================

'bookshelf': {
  id: 'bookshelf',
  name: 'Bookshelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 6 },
      { id: 'book', amount: 3 }
    ]
  }]
},

'chiseled-bookshelf': {
  id: 'chiseled-bookshelf',
  name: 'Chiseled Bookshelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 6 },
      { tag: 'slabs', amount: 3 }
    ]
  }]
},

// ==========================================
// LECTERN
// ==========================================

'lectern': {
  id: 'lectern',
  name: 'Lectern',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'slabs', amount: 4 },
      { id: 'bookshelf', amount: 1 }
    ]
  }]
},

// ==========================================
// ENCHANTING TABLE
// ==========================================

'enchanting-table': {
  id: 'enchanting-table',
  name: 'Enchanting Table',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'book', amount: 1 },
      { id: 'diamond', amount: 2 },
      { id: 'obsidian', amount: 4 }
    ]
  }]
},

// ==========================================
// BREWING STAND
// ==========================================

'brewing-stand': {
  id: 'brewing-stand',
  name: 'Brewing Stand',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'blaze-rod', amount: 1 },
      { id: 'cobblestone', amount: 3 }
    ]
  }]
},

'cauldron': {
  id: 'cauldron',
  name: 'Cauldron',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 7 }
    ]
  }]
},

// ==========================================
// BOTTLES & POTIONS (base items)
// ==========================================

'glass-bottle': {
  id: 'glass-bottle',
  name: 'Glass Bottle',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'glass', amount: 3 }
    ]
  }]
},



// ==========================================
// BEDS (crafted)
// ==========================================

'white-bed': {
  id: 'white-bed',
  name: 'White Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'orange-bed': {
  id: 'orange-bed',
  name: 'Orange Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'orange-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'magenta-bed': {
  id: 'magenta-bed',
  name: 'Magenta Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'magenta-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'light-blue-bed': {
  id: 'light-blue-bed',
  name: 'Light Blue Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'light-blue-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'yellow-bed': {
  id: 'yellow-bed',
  name: 'Yellow Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'yellow-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'lime-bed': {
  id: 'lime-bed',
  name: 'Lime Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'lime-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'pink-bed': {
  id: 'pink-bed',
  name: 'Pink Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'pink-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'gray-bed': {
  id: 'gray-bed',
  name: 'Gray Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gray-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'light-gray-bed': {
  id: 'light-gray-bed',
  name: 'Light Gray Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'light-gray-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'cyan-bed': {
  id: 'cyan-bed',
  name: 'Cyan Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'cyan-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'purple-bed': {
  id: 'purple-bed',
  name: 'Purple Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'purple-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'blue-bed': {
  id: 'blue-bed',
  name: 'Blue Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'blue-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'brown-bed': {
  id: 'brown-bed',
  name: 'Brown Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'brown-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'green-bed': {
  id: 'green-bed',
  name: 'Green Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'green-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'red-bed': {
  id: 'red-bed',
  name: 'Red Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'red-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

'black-bed': {
  id: 'black-bed',
  name: 'Black Bed',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'black-wool', amount: 3 },
      { tag: 'planks', amount: 3 }
    ]
  }]
},

// ==========================================
// DECORATIVE ITEMS
// ==========================================

'painting': {
  id: 'painting',
  name: 'Painting',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 8 },
      { id: 'white-wool', amount: 1 }
    ]
  }]
},

'item-frame': {
  id: 'item-frame',
  name: 'Item Frame',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 8 },
      { id: 'leather', amount: 1 }
    ]
  }]
},

'glow-item-frame': {
  id: 'glow-item-frame',
  name: 'Glow Item Frame',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'item-frame', amount: 1 },
      { id: 'glow-ink-sac', amount: 1 }
    ]
  }]
},

'armor-stand': {
  id: 'armor-stand',
  name: 'Armor Stand',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 6 },
      { id: 'stone-slab', amount: 1 }
    ]
  }]
},

'flower-pot': {
  id: 'flower-pot',
  name: 'Flower Pot',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'brick', amount: 3 }
    ]
  }]
},

// ==========================================
// BANNERS (simplified - just base)
// ==========================================

'white-banner': {
  id: 'white-banner',
  name: 'White Banner',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'white-wool', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// LEAD & HORSE ITEMS
// ==========================================

'lead': {
  id: 'lead',
  name: 'Lead',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'string', amount: 4 },
      { id: 'slime-ball', amount: 1 }
    ]
  }]
},



// ==========================================
// SHIELD
// ==========================================

'shield': {
  id: 'shield',
  name: 'Shield',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 6 },
      { id: 'iron-ingot', amount: 1 }
    ]
  }]
},

// ==========================================
// FISHING ROD
// ==========================================

'fishing-rod': {
  id: 'fishing-rod',
  name: 'Fishing Rod',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 3 },
      { id: 'string', amount: 2 }
    ]
  }]
},

// ==========================================
// FLINT AND STEEL
// ==========================================

'flint-and-steel': {
  id: 'flint-and-steel',
  name: 'Flint and Steel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 1 },
      { id: 'flint', amount: 1 }
    ]
  }]
},

// ==========================================
// SHEARS
// ==========================================

'shears': {
  id: 'shears',
  name: 'Shears',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 2 }
    ]
  }]
},

// ==========================================
// COMPASS & CLOCK
// ==========================================

'compass': {
  id: 'compass',
  name: 'Compass',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 4 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'clock': {
  id: 'clock',
  name: 'Clock',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 4 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'recovery-compass': {
  id: 'recovery-compass',
  name: 'Recovery Compass',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'echo-shard', amount: 8 },
      { id: 'compass', amount: 1 }
    ]
  }]
},

// ==========================================
// SPYGLASS
// ==========================================

'spyglass': {
  id: 'spyglass',
  name: 'Spyglass',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'amethyst-shard', amount: 1 },
      { id: 'copper-ingot', amount: 2 }
    ]
  }]
},

// ==========================================
// BRUSH
// ==========================================

'brush': {
  id: 'brush',
  name: 'Brush',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'feather', amount: 1 },
      { id: 'copper-ingot', amount: 1 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// ADDITIONAL REDSTONE ITEMS
// ==========================================

'target': {
  id: 'target',
  name: 'Target',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'redstone', amount: 4 },
      { id: 'hay-bale', amount: 1 }
    ]
  }]
},

'daylight-detector': {
  id: 'daylight-detector',
  name: 'Daylight Detector',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'glass', amount: 3 },
      { id: 'nether-quartz', amount: 3 },
      { tag: 'slabs', amount: 3 }
    ]
  }]
},

'tnt': {
  id: 'tnt',
  name: 'TNT',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gunpowder', amount: 5 },
      { id: 'sand', amount: 4 }
    ]
  }]
},

// ==========================================
// RAILS
// ==========================================

'rail': {
  id: 'rail',
  name: 'Rail',
  recipes: [{
    method: 'crafting_table',
    output: 16,
    ingredients: [
      { id: 'iron-ingot', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'powered-rail': {
  id: 'powered-rail',
  name: 'Powered Rail',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'gold-ingot', amount: 6 },
      { id: 'stick', amount: 1 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'detector-rail': {
  id: 'detector-rail',
  name: 'Detector Rail',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'iron-ingot', amount: 6 },
      { id: 'stone-pressure-plate', amount: 1 },
      { id: 'redstone', amount: 1 }
    ]
  }]
},

'activator-rail': {
  id: 'activator-rail',
  name: 'Activator Rail',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'iron-ingot', amount: 6 },
      { id: 'stick', amount: 2 },
      { id: 'redstone-torch', amount: 1 }
    ]
  }]
},

// ==========================================
// MINECARTS
// ==========================================

'minecart': {
  id: 'minecart',
  name: 'Minecart',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 5 }
    ]
  }]
},

'chest-minecart': {
  id: 'chest-minecart',
  name: 'Minecart with Chest',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'chest', amount: 1 },
      { id: 'minecart', amount: 1 }
    ]
  }]
},

'furnace-minecart': {
  id: 'furnace-minecart',
  name: 'Minecart with Furnace',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'furnace', amount: 1 },
      { id: 'minecart', amount: 1 }
    ]
  }]
},

'tnt-minecart': {
  id: 'tnt-minecart',
  name: 'Minecart with TNT',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'tnt', amount: 1 },
      { id: 'minecart', amount: 1 }
    ]
  }]
},

'hopper-minecart': {
  id: 'hopper-minecart',
  name: 'Minecart with Hopper',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'hopper', amount: 1 },
      { id: 'minecart', amount: 1 }
    ]
  }]
},

// ==========================================
// ADDITIONAL STORAGE ITEMS
// ==========================================

'ender-chest': {
  id: 'ender-chest',
  name: 'Ender Chest',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'obsidian', amount: 8 },
      { id: 'eye-of-ender', amount: 1 }
    ]
  }]
},

'trapped-chest': {
  id: 'trapped-chest',
  name: 'Trapped Chest',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'chest', amount: 1 },
      { id: 'tripwire-hook', amount: 1 }
    ]
  }]
},

// ==========================================
// COLORED SHULKER BOXES
// ==========================================

'white-shulker-box': {
  id: 'white-shulker-box',
  name: 'White Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'white-dye', amount: 1 }
    ]
  }]
},

'orange-shulker-box': {
  id: 'orange-shulker-box',
  name: 'Orange Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'orange-dye', amount: 1 }
    ]
  }]
},

'magenta-shulker-box': {
  id: 'magenta-shulker-box',
  name: 'Magenta Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'magenta-dye', amount: 1 }
    ]
  }]
},

'light-blue-shulker-box': {
  id: 'light-blue-shulker-box',
  name: 'Light Blue Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'light-blue-dye', amount: 1 }
    ]
  }]
},

'yellow-shulker-box': {
  id: 'yellow-shulker-box',
  name: 'Yellow Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'yellow-dye', amount: 1 }
    ]
  }]
},

'lime-shulker-box': {
  id: 'lime-shulker-box',
  name: 'Lime Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'lime-dye', amount: 1 }
    ]
  }]
},

'pink-shulker-box': {
  id: 'pink-shulker-box',
  name: 'Pink Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'pink-dye', amount: 1 }
    ]
  }]
},

'gray-shulker-box': {
  id: 'gray-shulker-box',
  name: 'Gray Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'gray-dye', amount: 1 }
    ]
  }]
},

'light-gray-shulker-box': {
  id: 'light-gray-shulker-box',
  name: 'Light Gray Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'light-gray-dye', amount: 1 }
    ]
  }]
},

'cyan-shulker-box': {
  id: 'cyan-shulker-box',
  name: 'Cyan Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'cyan-dye', amount: 1 }
    ]
  }]
},

'purple-shulker-box': {
  id: 'purple-shulker-box',
  name: 'Purple Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'purple-dye', amount: 1 }
    ]
  }]
},

'blue-shulker-box': {
  id: 'blue-shulker-box',
  name: 'Blue Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'blue-dye', amount: 1 }
    ]
  }]
},

'brown-shulker-box': {
  id: 'brown-shulker-box',
  name: 'Brown Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'brown-dye', amount: 1 }
    ]
  }]
},

'green-shulker-box': {
  id: 'green-shulker-box',
  name: 'Green Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'green-dye', amount: 1 }
    ]
  }]
},

'red-shulker-box': {
  id: 'red-shulker-box',
  name: 'Red Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'red-dye', amount: 1 }
    ]
  }]
},

'black-shulker-box': {
  id: 'black-shulker-box',
  name: 'Black Shulker Box',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'shulker-box', amount: 1 },
      { id: 'black-dye', amount: 1 }
    ]
  }]
},

// ==========================================
// WOODEN TOOLS
// ==========================================

'wooden-pickaxe': {
  id: 'wooden-pickaxe',
  name: 'Wooden Pickaxe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'wooden-axe': {
  id: 'wooden-axe',
  name: 'Wooden Axe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'wooden-shovel': {
  id: 'wooden-shovel',
  name: 'Wooden Shovel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'wooden-hoe': {
  id: 'wooden-hoe',
  name: 'Wooden Hoe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 2 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'wooden-sword': {
  id: 'wooden-sword',
  name: 'Wooden Sword',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 2 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// STONE TOOLS
// ==========================================

'stone-pickaxe': {
  id: 'stone-pickaxe',
  name: 'Stone Pickaxe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'stone-tier', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'stone-axe': {
  id: 'stone-axe',
  name: 'Stone Axe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'stone-tier', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'stone-shovel': {
  id: 'stone-shovel',
  name: 'Stone Shovel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'stone-tier', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'stone-hoe': {
  id: 'stone-hoe',
  name: 'Stone Hoe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'stone-tier', amount: 2 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'stone-sword': {
  id: 'stone-sword',
  name: 'Stone Sword',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'stone-tier', amount: 2 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// IRON TOOLS
// ==========================================

'iron-pickaxe': {
  id: 'iron-pickaxe',
  name: 'Iron Pickaxe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'iron-axe': {
  id: 'iron-axe',
  name: 'Iron Axe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'iron-shovel': {
  id: 'iron-shovel',
  name: 'Iron Shovel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'iron-hoe': {
  id: 'iron-hoe',
  name: 'Iron Hoe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 2 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'iron-sword': {
  id: 'iron-sword',
  name: 'Iron Sword',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 2 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// GOLDEN TOOLS
// ==========================================

'golden-pickaxe': {
  id: 'golden-pickaxe',
  name: 'Golden Pickaxe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'golden-axe': {
  id: 'golden-axe',
  name: 'Golden Axe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'golden-shovel': {
  id: 'golden-shovel',
  name: 'Golden Shovel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'golden-hoe': {
  id: 'golden-hoe',
  name: 'Golden Hoe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 2 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'golden-sword': {
  id: 'golden-sword',
  name: 'Golden Sword',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 2 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// DIAMOND TOOLS
// ==========================================

'diamond-pickaxe': {
  id: 'diamond-pickaxe',
  name: 'Diamond Pickaxe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'diamond-axe': {
  id: 'diamond-axe',
  name: 'Diamond Axe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'diamond-shovel': {
  id: 'diamond-shovel',
  name: 'Diamond Shovel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'diamond-hoe': {
  id: 'diamond-hoe',
  name: 'Diamond Hoe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 2 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'diamond-sword': {
  id: 'diamond-sword',
  name: 'Diamond Sword',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 2 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// NETHERITE TOOLS (smithing)
// ==========================================

'muddy-mangrove-roots': { 
  id: 'muddy-mangrove-roots', 
  name: 'Muddy Mangrove Roots', 
  recipes: [{ 
    method: 'crafting_table', 
    output: 1, 
    ingredients: [
      { id: 'mud', amount: 1 }, 
      { id: 'mangrove-roots', amount: 1 }
    ] 
  }] 
},

// ==========================================
// NETHERITE TOOLS (smithing)
// ==========================================

'netherite-pickaxe': {
  id: 'netherite-pickaxe',
  name: 'Netherite Pickaxe',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-pickaxe', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-axe': {
  id: 'netherite-axe',
  name: 'Netherite Axe',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-axe', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-shovel': {
  id: 'netherite-shovel',
  name: 'Netherite Shovel',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-shovel', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-hoe': {
  id: 'netherite-hoe',
  name: 'Netherite Hoe',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-hoe', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-sword': {
  id: 'netherite-sword',
  name: 'Netherite Sword',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-sword', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

// ==========================================
// LEATHER ARMOR
// ==========================================

'leather-helmet': {
  id: 'leather-helmet',
  name: 'Leather Cap',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'leather', amount: 5 }
    ]
  }]
},

'leather-chestplate': {
  id: 'leather-chestplate',
  name: 'Leather Tunic',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'leather', amount: 8 }
    ]
  }]
},

'leather-leggings': {
  id: 'leather-leggings',
  name: 'Leather Pants',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'leather', amount: 7 }
    ]
  }]
},

'leather-boots': {
  id: 'leather-boots',
  name: 'Leather Boots',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'leather', amount: 4 }
    ]
  }]
},

// ==========================================
// IRON ARMOR
// ==========================================

'iron-helmet': {
  id: 'iron-helmet',
  name: 'Iron Helmet',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 5 }
    ]
  }]
},

'iron-chestplate': {
  id: 'iron-chestplate',
  name: 'Iron Chestplate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 8 }
    ]
  }]
},

'iron-leggings': {
  id: 'iron-leggings',
  name: 'Iron Leggings',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 7 }
    ]
  }]
},

'iron-boots': {
  id: 'iron-boots',
  name: 'Iron Boots',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 4 }
    ]
  }]
},

// ==========================================
// GOLDEN ARMOR
// ==========================================

'golden-helmet': {
  id: 'golden-helmet',
  name: 'Golden Helmet',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 5 }
    ]
  }]
},

'golden-chestplate': {
  id: 'golden-chestplate',
  name: 'Golden Chestplate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 8 }
    ]
  }]
},

'golden-leggings': {
  id: 'golden-leggings',
  name: 'Golden Leggings',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 7 }
    ]
  }]
},

'golden-boots': {
  id: 'golden-boots',
  name: 'Golden Boots',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 4 }
    ]
  }]
},

// ==========================================
// DIAMOND ARMOR
// ==========================================

'diamond-helmet': {
  id: 'diamond-helmet',
  name: 'Diamond Helmet',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 5 }
    ]
  }]
},

'diamond-chestplate': {
  id: 'diamond-chestplate',
  name: 'Diamond Chestplate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 8 }
    ]
  }]
},

'diamond-leggings': {
  id: 'diamond-leggings',
  name: 'Diamond Leggings',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 7 }
    ]
  }]
},

'diamond-boots': {
  id: 'diamond-boots',
  name: 'Diamond Boots',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 4 }
    ]
  }]
},

// ==========================================
// NETHERITE ARMOR (smithing)
// ==========================================

'netherite-helmet': {
  id: 'netherite-helmet',
  name: 'Netherite Helmet',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-helmet', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-chestplate': {
  id: 'netherite-chestplate',
  name: 'Netherite Chestplate',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-chestplate', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-leggings': {
  id: 'netherite-leggings',
  name: 'Netherite Leggings',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-leggings', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

'netherite-boots': {
  id: 'netherite-boots',
  name: 'Netherite Boots',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'diamond-boots', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},


// ==========================================
// SPECIAL ARMOR
// ==========================================

'turtle-helmet': {
  id: 'turtle-helmet',
  name: 'Turtle Shell',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'scute', amount: 5 }
    ]
  }]
},

// ==========================================
// HORSE ARMOR
// ==========================================

'leather-horse-armor': {
  id: 'leather-horse-armor',
  name: 'Leather Horse Armor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'leather', amount: 7 }
    ]
  }]
},





// ==========================================
// WEAPONS
// ==========================================

'bow': {
  id: 'bow',
  name: 'Bow',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 3 },
      { id: 'string', amount: 3 }
    ]
  }]
},

'crossbow': {
  id: 'crossbow',
  name: 'Crossbow',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 3 },
      { id: 'iron-ingot', amount: 1 },
      { id: 'string', amount: 2 },
      { id: 'tripwire-hook', amount: 1 }
    ]
  }]
},

'arrow': {
  id: 'arrow',
  name: 'Arrow',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'flint', amount: 1 },
      { id: 'stick', amount: 1 },
      { id: 'feather', amount: 1 }
    ]
  }]
},

'spectral-arrow': {
  id: 'spectral-arrow',
  name: 'Spectral Arrow',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [
      { id: 'glowstone-dust', amount: 4 },
      { id: 'arrow', amount: 1 }
    ]
  }]
},


// ==========================================
// PALE OAK FAMILY
// ==========================================

'pale-oak-planks': {
  id: 'pale-oak-planks',
  name: 'Pale Oak Planks',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'pale-oak-log', amount: 1 }]
  }]
},

'pale-oak-stairs': {
  id: 'pale-oak-stairs',
  name: 'Pale Oak Stairs',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [{ id: 'pale-oak-planks', amount: 6 }]
  }]
},

'pale-oak-slab': {
  id: 'pale-oak-slab',
  name: 'Pale Oak Slab',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [{ id: 'pale-oak-planks', amount: 3 }]
  }]
},

'pale-oak-fence': {
  id: 'pale-oak-fence',
  name: 'Pale Oak Fence',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'pale-oak-planks', amount: 2 },
      { id: 'stick', amount: 4 }
    ]
  }]
},

'pale-oak-fence-gate': {
  id: 'pale-oak-fence-gate',
  name: 'Pale Oak Fence Gate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'stick', amount: 2 },
      { id: 'pale-oak-planks', amount: 4 }
    ]
  }]
},

'pale-oak-door': {
  id: 'pale-oak-door',
  name: 'Pale Oak Door',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [{ id: 'pale-oak-planks', amount: 6 }]
  }]
},

'pale-oak-trapdoor': {
  id: 'pale-oak-trapdoor',
  name: 'Pale Oak Trapdoor',
  recipes: [{
    method: 'crafting_table',
    output: 2,
    ingredients: [{ id: 'pale-oak-planks', amount: 6 }]
  }]
},

'pale-oak-button': {
  id: 'pale-oak-button',
  name: 'Pale Oak Button',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'pale-oak-planks', amount: 1 }]
  }]
},

'pale-oak-pressure-plate': {
  id: 'pale-oak-pressure-plate',
  name: 'Pale Oak Pressure Plate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'pale-oak-planks', amount: 2 }]
  }]
},

'pale-oak-sign': {
  id: 'pale-oak-sign',
  name: 'Pale Oak Sign',
  recipes: [{
    method: 'crafting_table',
    output: 3,
    ingredients: [
      { id: 'pale-oak-planks', amount: 6 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

'pale-oak-hanging-sign': {
  id: 'pale-oak-hanging-sign',
  name: 'Pale Oak Hanging Sign',
  recipes: [{
    method: 'crafting_table',
    output: 6,
    ingredients: [
      { id: 'stripped-pale-oak-log', amount: 2 },
      { id: 'iron-chain', amount: 2 }
    ]
  }]
},


// ==========================================
// RESIN BLOCKS
// ==========================================

'resin-block': {
  id: 'resin-block',
  name: 'Resin Block',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'resin-clump', amount: 9 }]
  }]
},

'resin-bricks': {
  id: 'resin-bricks',
  name: 'Resin Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'resin-block', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-block', amount: 1 }]
    }
  ]
},

'resin-brick-slab': {
  id: 'resin-brick-slab',
  name: 'Resin Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'resin-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'resin-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'resin-block', amount: 1 }]
    }
  ]
},

'resin-brick-stairs': {
  id: 'resin-brick-stairs',
  name: 'Resin Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'resin-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-block', amount: 1 }]
    }
  ]
},

'resin-brick-wall': {
  id: 'resin-brick-wall',
  name: 'Resin Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'resin-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-block', amount: 1 }]
    }
  ]
},

'chiseled-resin-bricks': {
  id: 'chiseled-resin-bricks',
  name: 'Chiseled Resin Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'resin-brick-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'resin-block', amount: 1 }]
    }
  ]
},


// ==========================================
// TUFF VARIANTS
// ==========================================

'tuff-slab': {
  id: 'tuff-slab',
  name: 'Tuff Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'tuff', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'tuff-stairs': {
  id: 'tuff-stairs',
  name: 'Tuff Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'tuff', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'tuff-wall': {
  id: 'tuff-wall',
  name: 'Tuff Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'tuff', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'polished-tuff': {
  id: 'polished-tuff',
  name: 'Polished Tuff',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'tuff', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'polished-tuff-slab': {
  id: 'polished-tuff-slab',
  name: 'Polished Tuff Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-tuff', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'polished-tuff-stairs': {
  id: 'polished-tuff-stairs',
  name: 'Polished Tuff Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-tuff', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'polished-tuff-wall': {
  id: 'polished-tuff-wall',
  name: 'Polished Tuff Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'polished-tuff', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'tuff-bricks': {
  id: 'tuff-bricks',
  name: 'Tuff Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'polished-tuff', amount: 4 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'tuff-brick-slab': {
  id: 'tuff-brick-slab',
  name: 'Tuff Brick Slab',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'tuff-bricks', amount: 3 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'tuff-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 2,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'tuff-brick-stairs': {
  id: 'tuff-brick-stairs',
  name: 'Tuff Brick Stairs',
  recipes: [
    {
      method: 'crafting_table',
      output: 4,
      ingredients: [{ id: 'tuff-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'tuff-brick-wall': {
  id: 'tuff-brick-wall',
  name: 'Tuff Brick Wall',
  recipes: [
    {
      method: 'crafting_table',
      output: 6,
      ingredients: [{ id: 'tuff-bricks', amount: 6 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'chiseled-tuff': {
  id: 'chiseled-tuff',
  name: 'Chiseled Tuff',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'tuff-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

'chiseled-tuff-bricks': {
  id: 'chiseled-tuff-bricks',
  name: 'Chiseled Tuff Bricks',
  recipes: [
    {
      method: 'crafting_table',
      output: 1,
      ingredients: [{ id: 'tuff-brick-slab', amount: 2 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff-bricks', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'polished-tuff', amount: 1 }]
    },
    {
      method: 'stonecutter',
      output: 1,
      priority: true,
      ingredients: [{ id: 'tuff', amount: 1 }]
    }
  ]
},

// ==========================================
// BUNDLES
// ==========================================

'bundle': {
  id: 'bundle',
  name: 'Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'string', amount: 2 },
      { id: 'leather', amount: 1 }
    ]
  }]
},

'white-bundle': {
  id: 'white-bundle',
  name: 'White Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'white-dye', amount: 1 }
    ]
  }]
},

'orange-bundle': {
  id: 'orange-bundle',
  name: 'Orange Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'orange-dye', amount: 1 }
    ]
  }]
},

'magenta-bundle': {
  id: 'magenta-bundle',
  name: 'Magenta Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'magenta-dye', amount: 1 }
    ]
  }]
},

'light-blue-bundle': {
  id: 'light-blue-bundle',
  name: 'Light Blue Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'light-blue-dye', amount: 1 }
    ]
  }]
},

'yellow-bundle': {
  id: 'yellow-bundle',
  name: 'Yellow Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'yellow-dye', amount: 1 }
    ]
  }]
},

'lime-bundle': {
  id: 'lime-bundle',
  name: 'Lime Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'lime-dye', amount: 1 }
    ]
  }]
},

'pink-bundle': {
  id: 'pink-bundle',
  name: 'Pink Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'pink-dye', amount: 1 }
    ]
  }]
},

'gray-bundle': {
  id: 'gray-bundle',
  name: 'Gray Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'gray-dye', amount: 1 }
    ]
  }]
},

'light-gray-bundle': {
  id: 'light-gray-bundle',
  name: 'Light Gray Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'light-gray-dye', amount: 1 }
    ]
  }]
},

'cyan-bundle': {
  id: 'cyan-bundle',
  name: 'Cyan Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'cyan-dye', amount: 1 }
    ]
  }]
},

'purple-bundle': {
  id: 'purple-bundle',
  name: 'Purple Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'purple-dye', amount: 1 }
    ]
  }]
},

'blue-bundle': {
  id: 'blue-bundle',
  name: 'Blue Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'blue-dye', amount: 1 }
    ]
  }]
},

'brown-bundle': {
  id: 'brown-bundle',
  name: 'Brown Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'brown-dye', amount: 1 }
    ]
  }]
},

'green-bundle': {
  id: 'green-bundle',
  name: 'Green Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'green-dye', amount: 1 }
    ]
  }]
},

'red-bundle': {
  id: 'red-bundle',
  name: 'Red Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'red-dye', amount: 1 }
    ]
  }]
},

'black-bundle': {
  id: 'black-bundle',
  name: 'Black Bundle',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'bundle', amount: 1 },
      { id: 'black-dye', amount: 1 }
    ]
  }]
},

// ==========================================
// WOLF ARMOR (1.21.4)
// ==========================================

'wolf-armor': {
  id: 'wolf-armor',
  name: 'Wolf Armor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'armadillo-scute', amount: 6 }]
  }]
},

// ==========================================
// NAUTILUS ARMOR (1.21.11)
// ==========================================

'copper-nautilus-armor': {
  id: 'copper-nautilus-armor',
  name: 'Copper Nautilus Armor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'copper-ingot', amount: 7 }]
  }]
},

'iron-nautilus-armor': {
  id: 'iron-nautilus-armor',
  name: 'Iron Nautilus Armor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'iron-ingot', amount: 7 }]
  }]
},

'golden-nautilus-armor': {
  id: 'golden-nautilus-armor',
  name: 'Golden Nautilus Armor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'gold-ingot', amount: 7 }]
  }]
},

'diamond-nautilus-armor': {
  id: 'diamond-nautilus-armor',
  name: 'Diamond Nautilus Armor',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'diamond', amount: 7 }]
  }]
},

'netherite-nautilus-armor': {
  id: 'netherite-nautilus-armor',
  name: 'Netherite Nautilus Armor',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'netherite-upgrade-smithing-template', amount: 1 },
      { id: 'diamond-nautilus-armor', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

// ==========================================
// SPEARS (1.21.11)
// ==========================================

'wooden-spear': {
  id: 'wooden-spear',
  name: 'Wooden Spear',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'planks', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'stone-spear': {
  id: 'stone-spear',
  name: 'Stone Spear',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { tag: 'stone-tier', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'copper-spear': {
  id: 'copper-spear',
  name: 'Copper Spear',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'iron-spear': {
  id: 'iron-spear',
  name: 'Iron Spear',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'iron-ingot', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'golden-spear': {
  id: 'golden-spear',
  name: 'Golden Spear',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'gold-ingot', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'diamond-spear': {
  id: 'diamond-spear',
  name: 'Diamond Spear',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'diamond', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'netherite-spear': {
  id: 'netherite-spear',
  name: 'Netherite Spear',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'netherite-upgrade-smithing-template', amount: 1 },
      { id: 'diamond-spear', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

// ==========================================
// NETHERITE HORSE ARMOR (1.21.11)
// ==========================================

'netherite-horse-armor': {
  id: 'netherite-horse-armor',
  name: 'Netherite Horse Armor',
  recipes: [{
    method: 'smithing',
    output: 1,
    ingredients: [
      { id: 'netherite-upgrade-smithing-template', amount: 1 },
      { id: 'diamond-horse-armor', amount: 1 },
      { id: 'netherite-ingot', amount: 1 }
    ]
  }]
},

// ==========================================
// BUCKET OF PUFFERFISH (1.21.11)
// ==========================================

'pufferfish-bucket': {
  id: 'pufferfish-bucket',
  name: 'Bucket of Pufferfish',
  recipes: [{
    method: 'interaction',
    tool: 'bucket',
    output: 1,
    ingredients: [
      { id: 'bucket', amount: 1 },
      { id: 'pufferfish', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER NUGGET
// ==========================================

'copper-nugget': {
  id: 'copper-nugget',
  name: 'Copper Nugget',
  recipes: [
    {
      method: 'crafting_table',
      output: 9,
      ingredients: [{ id: 'copper-ingot', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'copper-sword', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'copper-pickaxe', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'copper-axe', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'copper-shovel', amount: 1 }]
    },
    {
      method: 'smelting',
      output: 1,
      ingredients: [{ id: 'copper-hoe', amount: 1 }]
    }
  ]
},

// ==========================================
// COPPER TOOLS
// ==========================================

'copper-pickaxe': {
  id: 'copper-pickaxe',
  name: 'Copper Pickaxe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'copper-axe': {
  id: 'copper-axe',
  name: 'Copper Axe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 3 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'copper-shovel': {
  id: 'copper-shovel',
  name: 'Copper Shovel',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 1 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'copper-hoe': {
  id: 'copper-hoe',
  name: 'Copper Hoe',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 2 },
      { id: 'stick', amount: 2 }
    ]
  }]
},

'copper-sword': {
  id: 'copper-sword',
  name: 'Copper Sword',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 2 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER ARMOR
// ==========================================

'copper-helmet': {
  id: 'copper-helmet',
  name: 'Copper Helmet',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'copper-ingot', amount: 5 }]
  }]
},

'copper-chestplate': {
  id: 'copper-chestplate',
  name: 'Copper Chestplate',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'copper-ingot', amount: 8 }]
  }]
},

'copper-leggings': {
  id: 'copper-leggings',
  name: 'Copper Leggings',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'copper-ingot', amount: 7 }]
  }]
},

'copper-boots': {
  id: 'copper-boots',
  name: 'Copper Boots',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'copper-ingot', amount: 4 }]
  }]
},

// ==========================================
// COPPER HORSE ARMOR
// ==========================================

// ==========================================
// COPPER BARS
// ==========================================

'copper-bars': {
  id: 'copper-bars',
  name: 'Copper Bars',
  recipes: [{
    method: 'crafting_table',
    output: 16,
    ingredients: [{ id: 'copper-ingot', amount: 6 }]
  }]
},

'exposed-copper-bars': {
  id: 'exposed-copper-bars',
  name: 'Exposed Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'copper-bars', amount: 1 }]
  }]
},

'weathered-copper-bars': {
  id: 'weathered-copper-bars',
  name: 'Weathered Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'exposed-copper-bars', amount: 1 }]
  }]
},

'oxidized-copper-bars': {
  id: 'oxidized-copper-bars',
  name: 'Oxidized Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'weathered-copper-bars', amount: 1 }]
  }]
},

'waxed-copper-bars': {
  id: 'waxed-copper-bars',
  name: 'Waxed Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'copper-bars', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-exposed-copper-bars': {
  id: 'waxed-exposed-copper-bars',
  name: 'Waxed Exposed Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'exposed-copper-bars', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-weathered-copper-bars': {
  id: 'waxed-weathered-copper-bars',
  name: 'Waxed Weathered Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'weathered-copper-bars', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-oxidized-copper-bars': {
  id: 'waxed-oxidized-copper-bars',
  name: 'Waxed Oxidized Copper Bars',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'oxidized-copper-bars', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER CHAINS
// ==========================================

'copper-chain': {
  id: 'copper-chain',
  name: 'Copper Chain',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-ingot', amount: 1 },
      { id: 'copper-nugget', amount: 2 }
    ]
  }]
},

'exposed-copper-chain': {
  id: 'exposed-copper-chain',
  name: 'Exposed Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'copper-chain', amount: 1 }]
  }]
},

'weathered-copper-chain': {
  id: 'weathered-copper-chain',
  name: 'Weathered Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'exposed-copper-chain', amount: 1 }]
  }]
},

'oxidized-copper-chain': {
  id: 'oxidized-copper-chain',
  name: 'Oxidized Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'weathered-copper-chain', amount: 1 }]
  }]
},

'waxed-copper-chain': {
  id: 'waxed-copper-chain',
  name: 'Waxed Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'copper-chain', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-exposed-copper-chain': {
  id: 'waxed-exposed-copper-chain',
  name: 'Waxed Exposed Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'exposed-copper-chain', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-weathered-copper-chain': {
  id: 'waxed-weathered-copper-chain',
  name: 'Waxed Weathered Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'weathered-copper-chain', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-oxidized-copper-chain': {
  id: 'waxed-oxidized-copper-chain',
  name: 'Waxed Oxidized Copper Chain',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'oxidized-copper-chain', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER LANTERNS
// ==========================================

'copper-lantern': {
  id: 'copper-lantern',
  name: 'Copper Lantern',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'copper-nugget', amount: 8 },
      { id: 'copper-torch', amount: 1 }
    ]
  }]
},

'exposed-copper-lantern': {
  id: 'exposed-copper-lantern',
  name: 'Exposed Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'copper-lantern', amount: 1 }]
  }]
},

'weathered-copper-lantern': {
  id: 'weathered-copper-lantern',
  name: 'Weathered Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'exposed-copper-lantern', amount: 1 }]
  }]
},

'oxidized-copper-lantern': {
  id: 'oxidized-copper-lantern',
  name: 'Oxidized Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'weathered-copper-lantern', amount: 1 }]
  }]
},

'waxed-copper-lantern': {
  id: 'waxed-copper-lantern',
  name: 'Waxed Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'copper-lantern', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-exposed-copper-lantern': {
  id: 'waxed-exposed-copper-lantern',
  name: 'Waxed Exposed Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'exposed-copper-lantern', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-weathered-copper-lantern': {
  id: 'waxed-weathered-copper-lantern',
  name: 'Waxed Weathered Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'weathered-copper-lantern', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-oxidized-copper-lantern': {
  id: 'waxed-oxidized-copper-lantern',
  name: 'Waxed Oxidized Copper Lantern',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'oxidized-copper-lantern', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER TORCH
// ==========================================

'copper-torch': {
  id: 'copper-torch',
  name: 'Copper Torch',
  recipes: [{
    method: 'crafting_table',
    output: 4,
    ingredients: [
      { id: 'copper-nugget', amount: 1 },
      { id: 'stick', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER CHESTS
// ==========================================

'copper-chest': {
  id: 'copper-chest',
  name: 'Copper Chest',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'chest', amount: 1 },
      { id: 'copper-ingot', amount: 8 }
    ]
  }]
},

'exposed-copper-chest': {
  id: 'exposed-copper-chest',
  name: 'Exposed Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'copper-chest', amount: 1 }]
  }]
},

'weathered-copper-chest': {
  id: 'weathered-copper-chest',
  name: 'Weathered Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'exposed-copper-chest', amount: 1 }]
  }]
},

'oxidized-copper-chest': {
  id: 'oxidized-copper-chest',
  name: 'Oxidized Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'weathered-copper-chest', amount: 1 }]
  }]
},

'waxed-copper-chest': {
  id: 'waxed-copper-chest',
  name: 'Waxed Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'copper-chest', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-exposed-copper-chest': {
  id: 'waxed-exposed-copper-chest',
  name: 'Waxed Exposed Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'exposed-copper-chest', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-weathered-copper-chest': {
  id: 'waxed-weathered-copper-chest',
  name: 'Waxed Weathered Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'weathered-copper-chest', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-oxidized-copper-chest': {
  id: 'waxed-oxidized-copper-chest',
  name: 'Waxed Oxidized Copper Chest',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'oxidized-copper-chest', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

// ==========================================
// COPPER GOLEM
// ==========================================
// Copper Golem itself is spawned by placing carved pumpkin on copper block
// (interaction-based, not a crafting recipe)

// ==========================================
// COPPER GOLEM STATUES
// ==========================================

'copper-golem-statue': {
  id: 'copper-golem-statue',
  name: 'Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'copper-golem', amount: 1 }]
  }]
},

'exposed-copper-golem-statue': {
  id: 'exposed-copper-golem-statue',
  name: 'Exposed Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'copper-golem-statue', amount: 1 }]
  }]
},

'weathered-copper-golem-statue': {
  id: 'weathered-copper-golem-statue',
  name: 'Weathered Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'exposed-copper-golem-statue', amount: 1 }]
  }]
},

'oxidized-copper-golem-statue': {
  id: 'oxidized-copper-golem-statue',
  name: 'Oxidized Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'oxidation',
    output: 1,
    ingredients: [{ id: 'weathered-copper-golem-statue', amount: 1 }]
  }]
},

'waxed-copper-golem-statue': {
  id: 'waxed-copper-golem-statue',
  name: 'Waxed Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'copper-golem-statue', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-exposed-copper-golem-statue': {
  id: 'waxed-exposed-copper-golem-statue',
  name: 'Waxed Exposed Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'exposed-copper-golem-statue', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-weathered-copper-golem-statue': {
  id: 'waxed-weathered-copper-golem-statue',
  name: 'Waxed Weathered Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'weathered-copper-golem-statue', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

'waxed-oxidized-copper-golem-statue': {
  id: 'waxed-oxidized-copper-golem-statue',
  name: 'Waxed Oxidized Copper Golem Statue',
  recipes: [{
    method: 'interaction',
    tool: 'honeycomb',
    output: 1,
    ingredients: [
      { id: 'oxidized-copper-golem-statue', amount: 1 },
      { id: 'honeycomb', amount: 1 }
    ]
  }]
},

// ==========================================
// SHELVES
// ==========================================

'oak-shelf': {
  id: 'oak-shelf',
  name: 'Oak Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-oak-log', amount: 6 }]
  }]
},

'spruce-shelf': {
  id: 'spruce-shelf',
  name: 'Spruce Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-spruce-log', amount: 6 }]
  }]
},

'birch-shelf': {
  id: 'birch-shelf',
  name: 'Birch Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-birch-log', amount: 6 }]
  }]
},

'jungle-shelf': {
  id: 'jungle-shelf',
  name: 'Jungle Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-jungle-log', amount: 6 }]
  }]
},

'acacia-shelf': {
  id: 'acacia-shelf',
  name: 'Acacia Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-acacia-log', amount: 6 }]
  }]
},

'dark-oak-shelf': {
  id: 'dark-oak-shelf',
  name: 'Dark Oak Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-dark-oak-log', amount: 6 }]
  }]
},

'mangrove-shelf': {
  id: 'mangrove-shelf',
  name: 'Mangrove Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-mangrove-log', amount: 6 }]
  }]
},

'cherry-shelf': {
  id: 'cherry-shelf',
  name: 'Cherry Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-cherry-log', amount: 6 }]
  }]
},

'bamboo-shelf': {
  id: 'bamboo-shelf',
  name: 'Bamboo Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-bamboo-block', amount: 6 }]
  }]
},

'crimson-shelf': {
  id: 'crimson-shelf',
  name: 'Crimson Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-crimson-stem', amount: 6 }]
  }]
},

'warped-shelf': {
  id: 'warped-shelf',
  name: 'Warped Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-warped-stem', amount: 6 }]
  }]
},

'pale-oak-shelf': {
  id: 'pale-oak-shelf',
  name: 'Pale Oak Shelf',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [{ id: 'stripped-pale-oak-log', amount: 6 }]
  }]
},

'name-tag': {
  id: 'name-tag',
  name: 'Name Tag',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'string', amount: 1 },
      { id: 'paper', amount: 1 },
      { id: 'iron-ingot', amount: 1 }
    ]
  }]
},

'golden-dandelion': {
  id: 'golden-dandelion',
  name: 'Golden Dandelion',
  recipes: [{
    method: 'crafting_table',
    output: 1,
    ingredients: [
      { id: 'dandelion', amount: 1 },
      { id: 'gold-nugget', amount: 8 }
    ]
  }]
},

};